<template>
  <div>
    <el-dialog
      custom-class="bill-payment-dialog-by-job"
      :visible="visible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :append-to-body="appendToBody"
      :modal-append-to-body="modalAppendToBody"
      :show-close="false"
      :title="title"
      :width="!ifJc && customFields && customFields.length > 0 ? '1350px' : '960px'"
      top="5vh"
    >
      <div class="tabs-container">
        <el-tabs :active-name="activeTabName" @tab-click="handleClick">
          <el-tab-pane :label="$t('CargoMsg.Cargo_ApplicationForm')" name="applicationForm">
            <div class="app-main-inner-row" style="padding-bottom: 0;">
              <el-form
                :inline="true"
                style="width: 100%"
                label-width="90px"
                label-position="left"
                :disabled="readonly"
              >
                <div class="app-main-inner-row" style="padding-bottom: 0;">
                  <div style="flex: 1">
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Payment.applicationNo')">
                        <el-input
                          v-model="billPayment.billPaymentNo"
                          disabled="disabled"
                          style="width: 170px;"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.status')" label-width="50px">
                        <span>{{ stateText }}</span>
                      </el-form-item>
                    </div>
                    <el-form-item :label="$t('Payment.settleAccountsTo')">
                      <div style="display: flex">
                        <cargo-advance-select
                          filterable
                          :select-type="selectTypeNames.basic_data_Company"
                          :method-params="{customer:true}"
                          :default-value="Number(billPayment.accountId)||''"
                          style="width:170px;"
                          :tag-name="language"
                          disabled
                          @parentCallBack="p=>{billPayment.accountId=p.value;accountChange(p.value)}"
                        />
                        <div style="margin-left: 10px;display: flex; justify-content: space-between">
                          <el-checkbox
                            v-model="agentChecked"
                            :disabled="!readonly && this.settlementAgentArray.length == 0"
                            @change="cbSettlementAgentChange"
                          >
                            {{ $t('Payment.bySettlementAgent') }}
                          </el-checkbox>
                          <cargo-advance-select
                            filterable
                            :select-type="selectTypeNames.basic_data_Company"
                            :default-value="Number(billPayment.settlementAgentId) === 0 ? '' : Number(billPayment.settlementAgentId)"
                            :disabled="!agentChecked"
                            :cache="false"
                            :tag-name="language"
                            :static-options="settlementAgentArray"
                            style="margin-left: 10px"
                            @parentCallBack="p=>{billPayment.settlementAgentId=p.value;settlementAgentChange()}"
                          />
                        </div>
                      </div>
                    </el-form-item>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Partners.paymentType')">
                        <cargo-advance-select
                          no="paymentType"
                          filterable
                          :select-type="selectTypeNames.basic_data_PaymentType"
                          :default-value="billPayment.paymentType"
                          style="width:170px;"
                          tag-name="name"
                          @parentCallBack="p=>{billPayment.paymentType=p.value}"
                        />
                      </el-form-item>
                      <el-form-item v-if="!ifJc" required :label="$t('CargoMsg.Cargo_OurHeader')">
                        <cargo-advance-select
                          no="ourTitle"
                          :select-type="selectTypeNames.static_data_InvoiceTitle"
                          filterable
                          :cache="false"
                          :default-value="billPayment.ourTitle"
                          :static-options="ourInvoiceTitleArray"
                          @parentCallBack="ourTitleChangeEvent"
                        />
                      </el-form-item>
                    </div>
                    <el-form-item :label="$t('Payment.businessType')">
                      <el-checkbox-group v-model="jobTypes" disabled class="job-types-checkbox-group">
                        <el-checkbox label="SE">
                          {{ $t('Payment.oceanExport') }}
                        </el-checkbox>
                        <el-checkbox label="SI">
                          {{ $t('Payment.oceanImport') }}
                        </el-checkbox>
                        <el-checkbox label="AE">
                          {{ $t('Payment.airExport') }}
                        </el-checkbox>
                        <el-checkbox label="AI">
                          {{ $t('Payment.airImport') }}
                        </el-checkbox>
                        <el-checkbox label="RE">{{ $t('CargoMsg.Cargo_RailwayExport') }}</el-checkbox>
                        <el-checkbox label="RI">{{ $t('CargoMsg.Cargo_RailwayImport') }}</el-checkbox>
                        <el-checkbox label="IE">{{ $t('CargoMsg.Cargo_IntegratedJob') }}</el-checkbox>
                        <el-checkbox label="FBA">FBA</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('CargoMsg.Cargo_CurrencyOfPayment')">
                        <cargo-advance-select
                          style="width: 115px"
                          filterable
                          :clearable="false"
                          :select-type="selectTypeNames.basic_data_Currency"
                          :default-value="billPayment.currency"
                          @parentCallBack="p=>currencyChange(p.value, true)"
                        />
                      </el-form-item>
                      <el-form-item v-if="!billPayment.rateByCharge && ifHistoryPayment" :label="rateLabel">
                        <num-input
                          v-model="billPayment.rate"
                          :min="0"
                          :max="999999999"
                          :precision="8"
                          :truncated-precision="exchangeRatePrecision"
                          style="width: 120px;"
                          @blur="rateVerify"
                          @change="rateChange"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.amount')" label-width="50px">
                        <el-input-number
                          v-model="billPayment.amount"
                          :precision="billPayment.amount? 2 : 0"
                          :controls="false"
                          disabled
                          style="width: 115px;"
                        />
                      </el-form-item>
                      <el-form-item v-show="this.showWhtTax" :label="$t('FinanceManage.charge_notWhtAmount')" label-width="80px">
                        <el-input-number
                          v-model="billPayment.chargeNotWhtAmount"
                          style="width: 115px;"
                          :precision="billPayment.chargeNotWhtAmount? 2 : 0"
                          disabled
                          :controls="false"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Payment.paymentPeriod')">
                        <el-date-picker
                          v-model="billPayment.deadline"
                          type="date"
                          clearable
                          style="width: 170px;"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.methodOfPayment')">
                        <el-select v-model="billPayment.payType" style="width: 170px">
                          <el-option
                            v-for="(item,index) in receiveTypes"
                            :key="index"
                            :label="$store.getters.language === 'zh'?item.chineseName:item.englishName"
                            :value="Number(item.code)"
                          />
                        </el-select>
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Payment.invoiceHeader')">
                        <cargo-advance-select
                          v-if="showInvoiceTitle"
                          no="11"
                          :allow-create="true"
                          :select-type="selectTypeNames.static_data_Title"
                          filterable
                          :cache="false"
                          :default-value="billPayment.invoiceTitle"
                          :static-options="titleArray"
                          tag-name="title"
                          tag-value="title"
                          style="width:170px;"
                          @parentCallBack="invoiceTitleChange"
                        />
                      </el-form-item>
                      <el-form-item class="custom-textarea">
                        <template slot="label">
                          <span v-if="isSpecialExpensePaymentType" style="color: red;">*</span>
                          {{ $t('Payment.replaceInvoiceRemark') }}
                        </template>
                        <el-input
                          v-model="billPayment.replaceInvoiceRemark"
                          style="width: 170px"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Payment.bankOfDeposit')">
                        <cargo-advance-select
                          filterable
                          :select-type="selectTypeNames.static_data_TitleBank"
                          :default-value="billPayment.buyerBank"
                          :cache="false"
                          :static-options="buyerBankArray"
                          tag-value="bank"
                          tag-name="bank"
                          :allow-create="true"
                          style="width:170px;"
                          @parentCallBack="titleBankChange"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.bankAccount')">
                        <cargo-advance-select
                          :key="buyerBankAccountSelectKey"
                          filterable
                          :select-type="selectTypeNames.static_data_TitleBank"
                          :default-value="billPayment.buyerBankAccount"
                          :cache="false"
                          :static-options="buyerBankAccountArray"
                          tag-value="bankAccount"
                          tag-name="bankAccount"
                          :allow-create="true"
                          style="width:170px;"
                          @parentCallBack="buyerBankAccountChange"
                        />
                      </el-form-item>
                    </div>
                    <div class="el-form-item-wrapper">
                      <el-form-item :label="$t('Payment.applicant')">
                        <cargo-advance-select
                          :select-type="selectTypeNames.basic_data_User"
                          :default-value="Number(billPayment.inputBy)||''"
                          style="width:170px;"
                          disabled
                        />
                      </el-form-item>
                      <el-form-item :label="$t('Payment.dateOfApplication')">
                        <el-date-picker
                          v-model="billPayment.inputDate"
                          type="date"
                          :clearable="false"
                          style="width:170px;"
                        />
                      </el-form-item>
                    </div>
                    <template v-if="showEnterpriseWechatFields">
                      <div
                        v-for="(row, rowIndex) in enterpriseWechatSelectFieldRows"
                        :key="`enterprise-wechat-select-row-${rowIndex}`"
                        class="el-form-item-wrapper"
                      >
                        <el-form-item
                          v-for="field in row"
                          :key="field.prop"
                          :label="getEnterpriseWechatLabel(field)"
                          label-width="90px"
                        >
                          <!-- 企业微信扩展字段：用 type 区分渲染 input/select -->
                          <el-input
                            v-if="field.type === 'text'"
                            v-model="billPayment[field.prop]"
                            :disabled="!!field.disabled"
                            :style="{ width: '170px'}"
                          />
                          <cargo-advance-select
                            v-else
                            :default-value="billPayment[field.prop]"
                            :static-options="field.options"
                            filterable
                            :filter-type="'global'"
                            :filter-tag-names="field.prop === 'waterNotifier' ? ['label', 'userName', 'chineseName', 'englishName'] : ['label']"
                            :cache="false"
                            tag-name="label"
                            tag-value="value"
                            :disabled="!!field.disabled"
                            :style="{ width: '170px'}"
                            @parentCallBack="p => handleEnterpriseWechatSelectCallback(field, p)"
                          />
                        </el-form-item>
                      </div>
                    </template>
                    <div class="el-form-item-wrapper">
                      <el-form-item label="" style="margin-bottom: 0 !important;">
                        <el-checkbox v-model="billPayment.syncInvoiceAttachment" no="syncInvoiceAttachment">
                          {{ $t('CargoMsg.Cargo_SyncInvoiceAttachment') }}
                        </el-checkbox>
                      </el-form-item>
                    </div>
                  </div>
                  <div style="width: 290px;">
                    <div class="el-form-item-wrapper">
                      <el-form-item
                        :label="$t('Payment.invoiceNumber')"
                        label-width="100px"
                        class="custom-textarea"
                      >
                        <el-input
                          v-model="billPayment.invoiceNumber"
                          type="textarea"
                          :rows="6"
                          style="width:290px;"
                        />
                      </el-form-item>
                      <el-form-item
                        :label="$t('Payment.remarks')"
                        label-width="100px"
                        class="custom-textarea"
                      >
                        <el-input
                          v-model="billPayment.remark"
                          type="textarea"
                          :rows="6"
                          style="width:290px;"
                        />
                      </el-form-item>
                      <el-form-item :label="$t('CargoMsg.Cargo_PaymentReason')" label-width="100px" class="custom-textarea">
                        <el-input v-model="billPayment.paymentInstructions" no="paymentInstructions" type="textarea" :rows="5" style="width:290px;" />
                      </el-form-item>
                    </div>
                  </div>
                  <div v-if="!ifJc && customFields && customFields.length > 0" style="width: 340px; height:400px; margin-left: 52px">
                    <el-form-item
                      v-for="(customField, index) in customFields"
                      :key="index"
                      :label="isZh ? customField.chineseName: customField.englishName"
                      style="margin-left: 15px;margin-right: 0"
                      label-width="120px"
                    >
                      <el-input
                        v-if="customField.widgetType === SystemConstants.WIDGET_TYPE_TEXTBOX.code"
                        v-model="billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)]"
                        style="width:205px;"
                      />
                      <cargo-advance-select
                        v-if="customField.widgetType === SystemConstants.WIDGET_TYPE_DROPDOWN.code"
                        :default-value="billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)]"
                        :static-options="customField.enums"
                        filterable
                        :cache="false"
                        tag-name="tagName"
                        tag-value="tagValue"
                        style="width:205px;"
                        @parentCallBack="p=>{billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(customField.fieldCode)] = p ? p.tagValue : ''}"
                      />
                    </el-form-item>
                  </div>
                </div>
              </el-form>
            </div>
            <div v-if="readonly" class="reconciliation-mode-top">
              <el-radio-group v-model="reconciliationType" no="reconciliationMode" @change="reconciliationTypeChangeHandler">
                <el-radio no="viewedByJob" label="job">{{ $t('CargoMsg.Cargo_ViewedByJob') }}</el-radio>
                <el-radio no="viewedByFee" label="charge" style="margin-right:10px">{{ $t('CargoMsg.Cargo_ViewedByFee') }}</el-radio>
              </el-radio-group>
            </div>
            <div style="padding-top: 0;">
              <cargo-ag-grid
                config-module="190804"
                :grid-params.sync="gridParams"
                :grid-options="gridOptions"
                :column-defs="columnDefs"
                :row-data="rowData"
                style="width:100%;min-height:180px;"
              />
            </div>
            <div style="display: flex; margin-top:10px; justify-content: space-between;">
              <div style="display: flex;flex-wrap: wrap;justify-content: flex-start; align-items: center;">
                <el-form :inline="true" label-width="40px" label-position="right" style="display: flex;justify-content: space-between; align-items: center;">
                  <span v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge" style="vertical-align: middle">{{ $t('Invoice.invoice_currency') }} </span>&nbsp;&nbsp;<span v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge" style="font-weight: bold;vertical-align: middle">{{ billPayment.currency1 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item v-if="billPayment.currency1 && !ifHistoryPayment && !billPayment.rateByCharge" :label="$t('Invoice.invoice_exchangeRate')" :label-width="$selectByLang('', '95px')" style="margin-bottom: 0 !important;margin-right: 5px">
                    <num-input v-model="billPayment.rate1" :disabled="billPayment.currency1 === billPayment.currency || billPayment.payByBillingRate" no="rate1" :precision="8" :truncated-precision="rate1Precision" style="width: 95px;" @change="p=>{currencyRateChanged(p, 'currency1')}" />
                  </el-form-item>
                  <span v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge" style="vertical-align: middle">{{ $t('Invoice.invoice_currency') }} </span>&nbsp;&nbsp;<span v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge" style="font-weight: bold;vertical-align: middle">{{ billPayment.currency2 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item v-if="billPayment.currency2 && !ifHistoryPayment && !billPayment.rateByCharge" :label="$t('Invoice.invoice_exchangeRate')" :label-width="$selectByLang('', '95px')" style="margin-bottom: 0 !important;margin-right: 5px">
                    <num-input v-model="billPayment.rate2" :disabled="billPayment.currency2 === billPayment.currency || billPayment.payByBillingRate" no="rate2" :precision="8" :truncated-precision="rate2Precision" style="width: 95px;" @change="p=>{currencyRateChanged(p, 'currency2')}" />
                  </el-form-item>
                  <span v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge" style="vertical-align: middle">{{ $t('Invoice.invoice_currency') }} </span>&nbsp;&nbsp;<span v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge" style="font-weight: bold;vertical-align: middle">{{ billPayment.currency3 }}<i class="el-icon-right" />{{ billPayment.currency }}</span>
                  <el-form-item v-if="billPayment.currency3 && !ifHistoryPayment && !billPayment.rateByCharge" :label="$t('Invoice.invoice_exchangeRate')" :label-width="$selectByLang('', '95px')" style="margin-bottom: 0 !important;margin-right: 5px">
                    <num-input v-model="billPayment.rate3" :disabled="billPayment.currency3 === billPayment.currency || billPayment.payByBillingRate" no="rate3" :precision="8" :truncated-precision="rate3Precision" style="width: 95px;" @change="p=>{currencyRateChanged(p, 'currency3')}" />
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 0 !important;margin-right: 5px">
                    <el-checkbox v-if="!ifHistoryPayment && !billPayment.rateByCharge" v-model="billPayment.payByBillingRate" :disabled="!canUseBillingRate" no="payByBillingRate" @change="payByBillingRateChanged">{{ $t('CargoMsg.Cargo_PayByBillingRate') }}</el-checkbox>
                  </el-form-item>
                  <el-form-item label="" style="margin-bottom: 0 !important;">
                    <el-checkbox v-if="showRateByCharge" v-model="billPayment.rateByCharge" no="rateByCharge" @change="rateByChargeChanged">{{ $t('WriteOff.rateByCharge') + $t('CargoMsg.Cargo_Create') }}</el-checkbox>
                  </el-form-item>
                </el-form>
              </div>
            </div>
            <div style="display: flex; margin-top:10px; justify-content: space-between;">
              <div style="display: flex;flex-wrap: wrap;justify-content: flex-start; align-items: center;">
                <span>{{ $t('Payment.total') }}</span>
                <charge-currency-total-group
                  :key="1"
                  ar-field="chargeReceivable"
                  :data-field="reconciliationType === 'charge' ? 'chargeAmount':'chargeAmounts'"
                  currency-field="chargeCurrency"
                  rate-field="chargeRate"
                  arap-order="ap"
                  type="auto"
                  :data-provider="rowData"
                />
              </div>
              <!--      <cargo-pagination-->
              <!--        :total="total"-->
              <!--        :page.sync="pagination.pageNum"-->
              <!--        :limit.sync="pagination.pageSize"-->
              <!--        @pagination="queryPageHandler"-->
              <!--      />-->
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="billPayment.uuid" :label="$t('CargoMsg.Cargo_FileHistory')" name="fileHistory" :lazy="true" style="height: 503px;">
            <file-history :bill-payment-uuid="curBillPaymentUuid" :uuid="curBillPaymentUuid" :state="billPayment.state" :input-by="$store.getters.userId" grid-height="477px" module-name="billPayment" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div slot="footer">
        <span v-if="activeTabName==='applicationForm' && billPayment.state == 0" style="position: absolute; left: 20px;">
          <el-button
            v-if="activeTabName==='applicationForm' && billPayment.uuid && billPayment.state == 0"
            type="primary"
            @click="addCharge"
          >
            {{ $t('Payment.addCharge') }}
          </el-button>
          <el-button
            v-if="activeTabName==='applicationForm' && billPayment.state == 0"
            type="primary"
            @click="removeCharge"
          >
            {{ $t('Payment.removeCharge') }}
          </el-button>
          <!--          <el-button v-if="activeTabName==='applicationForm' && billPayment.state === 0" type="primary" @click="toSplitCharge">{{ $t('Invoice.invoice_sp31') }}</el-button>-->
        </span>
        <span style="padding-right: 10px;">
          <el-button v-if="activeTabName==='applicationForm' && !billPayment.uuid" type="primary" @click="toPreStep">
            {{ $t('Payment.back') }}
          </el-button>
          <el-button v-if="activeTabName==='applicationForm' && billPayment.uuid" type="primary" @click="doPrint">
            {{ $t('Payment.print') }}
          </el-button>
          <el-button
            v-if="billPayment.uuid"
            v-show="$checkPermission(['button_fmBillPaymentByJob_billPaymentHandle'])"
            type="primary"
            @click="processPaymentRequest"
          >
            {{ $t('Payment.processPaymentRequest') }}
          </el-button>
          <el-button
            v-if="billPayment.uuid && billPayment.state == 0"
            type="primary"
            :loading="commitSubmitting"
            :disabled="commitSubmitting"
            @click="doCommitPre"
          >
            {{ $t('Payment.submit') }}
          </el-button>
          <el-button v-if="$checkPermission(['button_fmBillPaymentByJob_invoicePoolHandle'])" type="primary" :disabled="readonly || btnSaveEnable" @click="showInvoicePoolDialog">
            {{ $t('CargoMsg.Cargo_InvoicePoolReceiving') }}
          </el-button>
          <el-button type="primary" :disabled="readonly || btnSaveEnable" @click="doSavePre">
            {{ $t('Payment.save') }}
          </el-button>
          <el-button @click="cancel">{{ $t('Payment.cancel') }}</el-button>
        </span>
      </div>
      <!--打印模板-->
      <cargo-template-selector-dialog
        :visible.sync="templateSelectorDialog.visible"
        :ctx="templateSelectorDialog.cxt"
        :category="templateSelectorDialog.category"
        :data="templateSelectorDialog.data"
        @selectedTemplate="updatePrintField"
      />
      <!--加入费用-->
      <join-charge-dialog
        v-if="joinChargeDialog.visible"
        :visible.sync="joinChargeDialog.visible"
        search-item-module="5043"
        :default-conditions="joinChargeDialog.addChargeCondition"
        charge-state-param="BillPaymentChargeState"
        @addChargeCallBackEvent="addChargeCallBack"
      />
      <!-- 发票池弹窗 -->
      <invoice-pool-dialog
        v-if="invoicePoolDialog.visible"
        :visible.sync="invoicePoolDialog.visible"
        :seller-tax-name-default-value="invoicePoolDialog.sellerTaxNameDefaultValue"
        :selected-entities="invoicePoolDialog.selectedEntities"
        :make-invoice-method="invoicePoolDialog.makeInvoiceMethod"
        :source="invoicePoolDialog.source"
        :operation="invoicePoolDialog.operation"
        :callback="invoicePoolCallBack"
      />
      <!-- 付款申请审批流 -->
      <bill-payment-work-flow-apply-dialog
        v-if="workFlowApplyDialog.visible"
        :visible.sync="workFlowApplyDialog.visible"
        :bill-payment="billPayment"
        :title="$t('CargoMsg.Cargo_SubmitAPaymentRequestForApproval')"
        type="apply"
        :show-wht="showWht"
        @close="workFlowApplyDialog.visible=false"
        @closeAndRefresh="applyCloseAndRefresh"
      />
    </el-dialog>
    <!-- 多条业务，配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :bill-payments="batchCheckingWindow.billPayments"
      :call-back="batchCheckingWindow.callBack"
    />
    <!--  费用拆分弹窗页  -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="splitChargeDialog.show"
      :title="$t('CargoMsg.Cargo_Sp31')"
      width="760px"
      class="make-invoice-step-two-split-charge-dialog"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <el-form
        :inline="true"
        :model="splitChargeDialog.splitChargeForm"
        label-width="70px"
        label-position="right"
      >
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_OriginalExpenseP')">
            <span>{{ splitChargeDialog.charge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.charge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')">
            <span>{{ splitChargeDialog.charge.amount }}</span>
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item :label="$t('CargoMsg.Cargo_SplitExpenseP')">
            <span>{{ splitChargeDialog.splitCharge.chargeName }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_CurrencyP')">
            <span>{{ splitChargeDialog.splitCharge.currency }}</span>
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxIncludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.amount"
              no="amount"
              :precision="2"
              controls-position="right"
              :controls="false"
              @change="amountChangeHandler"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxExcludedPriceP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.excludingTaxAmount"
              no="excludingTaxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
        <div class="el-form-item-wrapper">
          <el-form-item label=" " />
          <el-form-item label=" " />
          <el-form-item :label="$t('CargoMsg.Cargo_TaxAmountP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxAmount"
              no="taxAmount"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Cargo_TaxRateP')" class="custom-form-item-w">
            <el-input-number
              v-model="splitChargeDialog.splitCharge.taxRate"
              no="taxRate"
              :precision="2"
              :min="-99999999"
              :max="99999999"
              controls-position="right"
              :disabled="true"
            />
          </el-form-item>
        </div>
      </el-form>
      <div slot="footer">
        <span style="position: absolute; left: 0; padding-left: 10px;">
          <el-checkbox v-model="splitChargeDialog.onlyChangeQuantity" no="onlyChangeQuantity" @change="onlyChangeQuantityChangeHandler">{{ $t('Invoice.invoice_SplitChargeOnlyChangeQuantity') }}</el-checkbox>
        </span>
        <el-button no="ok" type="primary" :disabled="splitChargeDialog.btnSplitEnable" @click="doSplitCharge">{{ $t('common.btn.ok') }}</el-button>
        <el-button no="cancel" @click="splitChargeDialog.show = false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>

    <!--特殊审批-->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="specialDialog.visible"
      :title="$t('CargoMsg.Cargo_SpecialApproval2')"
      width="580px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div class="dialog-content">
        <el-form
          ref="specialForm"
          :inline="true"
          :model="specialDialog"
          label-width="100px"
          label-position="right"
        >
          <el-form-item :label="$t('CargoMsg.Application_Item')" style="margin-top: 10px">
            <cargo-advance-select
              :default-value="specialDialog.applyMatter"
              :static-options="[{code:'专项超过毛利2倍申请'}]"
              filterable
              tag-name="code"
              tag-value="code"
              :disabled="true"
              :cache="false"
              style="width:400px;"
            />
          </el-form-item>
          <el-form-item :label="$t('CargoMsg.Application_Reason')" style="margin-top: 20px">
            <el-input v-model="specialDialog.applyReason" type="textarea" :rows="4" style="width:400px;" />
          </el-form-item>
          <el-form-item :label="$t('Pricing.Attachment')" style="margin-top: 20px">
            <div class="upload-file-row" style="margin-left: 40px">
              <template v-if="hasUploadedSpecialFile()">
                <span class="upload-file-name">{{ getSpecialUploadedFileName() }}</span>
                <el-button
                  class="upload-file-remove"
                  type="text"
                  icon="el-icon-close"
                  @click="handleRemoveSpecialUpload"
                />
              </template>
              <el-button v-else type="primary" @click="cloudFile.visible=true">
                {{ $t('CargoMsg.Action_AddAttachment') }}
              </el-button>
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" style="text-align: center;margin-top: 20px">
          <el-button no="ok" type="primary" @click="doApproval">{{ $t('common.btn.ok') }}</el-button>
          <el-button no="cancel" @click="specialDialog.visible = false">{{ $t('common.btn.cancel') }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :lob="cloudFile.lob"
      @uploadDone="data => {uploadSuccess(data);}"
    />
  </div>
</template>

<script>
import { getCustomFieldList } from '@/api/sysManage/baseConfig/customFieldDisplayConfiguration'
import { ApiCacheManage } from '@/utils/commonUtil'
import { getInvoiceTitlesByOffice } from '@/api/sysManage/officeInvoiceTitle'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { BillPayment } from '@/class/model/act/BillPayment'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import ColumnUtils from '@/utils/ColumnUtils'
import { formatNumberToThousands } from '@/utils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import * as ClearingConstants from '@/class/cargo/model/parameters/ClearingConstants'
import URL from '@/api/urlTranslator'
import {
  queryBillPaymentDetail,
  queryChargeOfBillPayment,
  createBillPayment,
  updateBillPayment,
  updateBillPaymentState,
  getChargeBillingMultiCurrencyInfo,
  queryJobOfBillPayment,
  uploadHasPrint,
  checkBillPaymentJobSettleFunc,
  checkLackInvoiceFlagFunc
} from '@/api/clearing/billPayment'
import { loadChargeByUuids } from '@/api/clearing/billingNative'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { autoBillPaymentWriteOffFunc } from '@/api/clearing/actualAmount'
import { getObjectByCache, getCacheListByKey, getFilterCacheList } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { buildApproveContent } from './billPaymentApproval'
import { normalizeBillPaymentJobSettleCheck } from './billPaymentJobSettleCheck'
import { resolveSpecialFeeApprovalRoute } from './specialFeeApprovalRoute'
import { allTitleBanksByCmpIdx, upsertPartnerTitleBank } from '@/api/partner/titleBank'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import * as NumberUtils from '@/utils/NumberUtils'
import { getGridSelected } from '@/utils/agGrid'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import { cacheName, cache } from '@/utils/cacheManager'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import chargeCurrencyTotalGroup from '@/components/Cargo/Act/chargeSummary/ChargeCurrencyTotalGroup.vue'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import DateUtils from '@/utils/dateUtils'
import fileHistory from '@/views/cargo/v0/Clearing/components/BillPayment/fileHistory'
import { getJumpFinaceOrBusinessAttrs } from '@/components/Cargo/grid/routerAndPrintHelp'
import BillPaymentWorkFlowApplyDialog from '@/components/Cargo/Common/Wrokflow/billPaymentApplyDialog'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import NumInput from '@/components/Cargo/Common/NumInput'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import CustomLableUtils from '@/utils/CustomLabelUtils'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import billPaymentDialog from '@/views/cargo/v0/Clearing/components/BillPayment/billPaymentDialog.vue'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import { saveSplitCharge } from '@/api/clearing/invoice'
import { Company } from '@/class/model/mdm/Company'
import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload.vue'
import { Project } from '@/class/model/pm/Project'
import enterpriseWechatMixin from '@/views/cargo/v0/Clearing/components/BillPaymentByJob/enterpriseWechatMixin'
import InvoicePoolDialog from '@/views/cargo/v0/Clearing/components/invoicePool/invoicePoolDialog'

export default {
  name: 'BillPaymentDialogByJob',
  components: {
    cargoCloudFileUpload,
    billPaymentDialog,
    BatchCheckingWindow,
    cargoTemplateSelectorDialog,
    joinChargeDialog,
    cargoAdvanceSelect,
    chargeCurrencyTotalGroup,
    fileHistory,
    BillPaymentWorkFlowApplyDialog,
    InvoicePoolDialog,
    NumInput
  },
  mixins: [enterpriseWechatMixin],
  props: {
    appendToBody: { type: Boolean, default: false },
    modalAppendToBody: { type: Boolean, default: false },
    visible: { type: Boolean, required: true },
    title: { type: String, required: false, default: '查看付款申请单' },
    billPaymentUuid: { type: String, required: false, default: '' }, // 付款申请单Uuid
    isDirectPayment: { type: Boolean, required: false, default: false }, // 是否直达
    location: { type: String, required: false },
    viewSource: { type: String, default: '' } // 页面请求发起方
  },
  data() {
    return {
      SystemConstants,
      customFields: [],
      getInvoiceTitlesByOfficeCache: new ApiCacheManage(getInvoiceTitlesByOffice), // getInvoiceTitlesByOffice缓存管理
      ourInvoiceTitleArray: [], // 我方发票抬头选项
      curBillPaymentUuid: '',
      billPayment: {},
      currencyRateMap: {},
      billingList: [],
      billCurrencyList: [],
      canUseBillingRate: false,
      reconciliationType: 'charge',
      loading: false,
      commitSubmitting: false,
      selectTypeNames: TYPE_NAMES,
      URL,
      agentChecked: 0, // 是否选中使用结算代理 1是 0否
      jobTypes: [],
      settlementAgentArray: [], // 结算代理数据源
      titleBankArray: [], // 开户银行数据源
      allTitleBankCache: [], // 开票抬头开户行/账号完整数据源（用于二次筛选）
      otherCurrencyArray: [], // 费用列表中与付款申请单币种不同的费用币种集合
      receiveTypes: ClearingConstants.AMOUNT_RECEIVE_TYPES, // 收付方式源
      rateLabel: this.$t('Payment.exchangeRate'), // 汇率label
      gridOptions: {
        rowSelection: 'multiple',
        defaultColDef: {
          filter: false
        },
        // 行背景色设置
        getRowStyle: function(params) {
          const rowStyle = {}
          if (params.data.ifDirty) {
            Object.assign(rowStyle, { background: '#FF0000' })
            return rowStyle
          }
        }
      },
      language: 'chineseName',
      gridParams: {},
      gridApi: {},
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: [],
      pagination: {
        pageNum: 1,
        total: 0,
        pageSize: 5000
      },
      stateText: '', // 付款申请单状态
      templateSelectorDialog: { // 模板选择弹窗
        visible: false,
        cxt: null,
        category: 'BILLPAYMENT',
        data: {
          BILLPAYMENT_UUID: '',
          BILL_PAYMENT_UUID: ''
        }
      },
      joinChargeDialog: { // 加入费用弹窗
        visible: false,
        addChargeCondition: { // 点击加入费用按钮时传递的参数
          exceptKeys: [],
          hasBillPayment: -1,
          hasBilling: -1,
          oversea: -1,
          accountId: 0,
          viewSource: 'BillPaymentDetail_AddCharge' // 页面请求发起方
        }
      },
      invoicePoolDialog: {
        visible: false,
        sellerTaxNameDefaultValue: '',
        selectedEntities: [],
        source: 'invoice',
        operation: 'collection',
        makeInvoiceMethod: 1
      },
      departmentArray: [], // 付款申请结算公司数据源
      enterpriseWechatWaterNotifierOptions: [],
      btnSaveEnable: false,
      activeTabName: 'applicationForm', // 当前展示页签
      workFlowApplyDialog: {
        visible: false
      },
      defaultTitle: '',
      existDistinctTitle: false,
      showInvoiceTitle: true,
      isSpecialExpenseEntryFunction: false,
      titleArray: [],
      batchCheckingWindow: {
        lob: SystemConstants.SE.code,
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        newJob: null,
        billPayments: []
      },
      splitChargeDialog: {
        show: false,
        charge: {}, // 要拆分的费用
        chargeOrigin: {},
        splitCharge: {
          chargeName: '', // 费用名称
          currency: '', // 币种
          amount: 0.0, // 含税价
          taxRate: 0.0, // 税率
          taxAmount: 0.0, // 税额
          excludingTaxAmount: 0.0, // 不含税额
          quantity: 1, // 数量
          billingAmount: 0.0, // 对帐金额
          remarks: '' // 备注
        }, // 拆分的费用
        splitChargeForm: {
        },
        btnSplitEnable: false,
        onlyChangeQuantity: true // 拆分后“单价”不变，“数量”更新
      },
      specialDialog: {
        visible: false,
        billPaymentUuid: '',
        applyMatter: '专项超过毛利2倍申请',
        applyReason: '',
        fileList: []
      },
      cloudFile: {
        visible: false,
        job: new Project(),
        lob: 'allLob'
      }
    }
  },
  computed: {
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    isSpecialExpensePaymentType() {
      if (!this.billPayment || this.billPayment.paymentType === undefined || this.billPayment.paymentType === null || this.billPayment.paymentType === '') {
        return false
      }
      const typeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PaymentType, 'code', this.billPayment.paymentType, 'name')
      return typeName === this.$t('CargoMsg.Cargo_SpecialExpenseApplication')
    },
    showWhtTax() {
      return this.$store.getters.currentOffice.whtTaxMode
    },
    total() {
      return this.rowData.length
    },
    buyerBankArray() {
      // Unique bank list for current invoiceTitle + currency. The raw rows live in titleBankArray.
      const rows = Array.isArray(this.titleBankArray) ? this.titleBankArray : []
      const map = new Map()
      for (const row of rows) {
        if (!row) continue
        const bank = row.bank ? String(row.bank).trim() : ''
        if (!bank) continue
        if (!map.has(bank)) {
          map.set(bank, { bank })
        }
      }
      return Array.from(map.values())
    },
    buyerBankAccountArray() {
      // Bank account list depends on selected invoiceTitle + currency (via titleBankArray) and selected bank.
      const rows = Array.isArray(this.titleBankArray) ? this.titleBankArray : []
      const bank = (this.billPayment && this.billPayment.buyerBank) ? String(this.billPayment.buyerBank).trim() : ''
      if (!bank) return []

      const map = new Map()
      for (const row of rows) {
        if (!row) continue
        if (row.bank !== bank) continue
        const bankAccount = row.bankAccount ? String(row.bankAccount).trim() : ''
        if (!bankAccount) continue
        if (!map.has(bankAccount)) {
          map.set(bankAccount, { ...row, bankAccount })
        }
      }
      return Array.from(map.values())
    },
    buyerBankAccountSelectKey() {
      const bank = this.billPayment && this.billPayment.buyerBank ? String(this.billPayment.buyerBank).trim() : ''
      const invoiceTitle = this.billPayment && this.billPayment.invoiceTitle ? String(this.billPayment.invoiceTitle).trim() : ''
      const currency = this.billPayment && this.billPayment.currency ? String(this.billPayment.currency).trim() : ''
      return `${bank}__${invoiceTitle}__${currency}`
    },
    // REQ-0033：企微字段配置由后端清洗下发（titles/options/required/optionsSource），mixin 持有 enterpriseWechatFormFields
    enterpriseWechatFields() {
      return Array.isArray(this.enterpriseWechatFormFields) ? this.enterpriseWechatFormFields : []
    },
    // 取数触发键：付款类型 × 当前公司（右上角）任一变化即重取（保留 REQ-0027 切公司/切类型联动语义）
    wechatFormConfigTrigger() {
      const paymentType = this.billPayment && this.billPayment.paymentType
      const officeCode = (this.$store.getters.currentOffice || {}).code
      return `${paymentType === undefined || paymentType === null ? '' : paymentType}|${officeCode || ''}`
    },
    enterpriseWechatSelectFieldRows() {
      // hidden 字段（如后端未下发数据的所在部门）不参与渲染
      const selectFields = this.enterpriseWechatFields.filter(field => field && !field.hidden)
      const rows = []
      for (let i = 0; i < selectFields.length; i += 2) {
        rows.push(selectFields.slice(i, i + 2))
      }
      return rows
    },
    readonly() { // 付款申请单是否可编辑
      return this.billPayment && !!this.billPayment.uuid && this.billPayment.state !== '' && this.billPayment.state !== 0
    },
    showEnterpriseWechatFields() {
      return Array.isArray(this.enterpriseWechatFormFields) && this.enterpriseWechatFormFields.length > 0
    },
    enterpriseWechatTextFields() {
      return this.enterpriseWechatFields.filter(field => field && field.type === 'text')
    },
    columnDefs() {
      let list = []
      if (this.reconciliationType === 'job') {
        list = [
          {
            headerName: '', checkboxSelection: true,
            sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
            headerCheckboxSelection: true
          },
          {
            headerName: this.$t('Payment.businessNumber'), field: 'jobJobNo', width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: {
                useRoute: true,
                usePrint: true,
                routeName: 'FinanceManage',
                routeParamKeys: { jobNo: 'jobJobNo' },
                routeTitle: this.$t('Clearing.FinancialAudit'),
                routePermissions: ['module_ACVerify'],
                extraRouteParams: {}
              }
            }
          },
          { headerName: this.$t('Payment.mbl'), field: 'jobMbl', width: 200 },
          {
            headerName: this.$t('Payment.consignationCompany'), field: 'jobCustomerId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.settleAccountsTo'), field: 'chargeAccountId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.carrierId'), field: 'jobCarrierId', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.SONO'), field: 'jobSoNo', width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'so-no-render',
              attrs: {
                divider: ' '
              }
            }
          },
          {
            headerName: this.$t('SeaExport.OverseaCustomerService'), field: 'jobOverseaOp', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.businessType'), field: 'jobLob', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.jobBussStateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Payment.businessDate'), field: 'jobBusinessDate', width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          { headerName: this.$t('Payment.vesselAndVoyage'), field: 'jobVessel', width: 200 },
          {
            headerName: this.$t('Payment.portOfLoading'), field: 'jobLoadingPortCode', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Payment.portOfDestination'), field: 'jobDestinationPortCode', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Seaport, 'code', params.value, 'englishName')
            }
          },
          {
            headerName: this.$t('Payment.operation'), field: 'jobOp', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.sales'), field: 'jobSales', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.accrued'), field: 'jobProvisioned', width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.booleanLabelFunction(params.value)
            }
          },
          { headerName: this.$t('Payment.currency'), field: 'chargeCurrency', width: 200 },
          {
            headerName: this.$t('Payment.taxIncludedPrice'), field: 'chargeAmounts', width: 200,
            cellRenderer: (params) => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          { headerName: this.$t('SeaExport.UserDefinedField1'), field: 'jobUserDefinedField1', width: 200 },
          { headerName: this.$t('SeaExport.UserDefinedField2'), field: 'jobUserDefinedField2', width: 200 },
          { headerName: this.$t('SeaExport.UserDefinedField3'), field: 'jobUserDefinedField3', width: 200 },
          {
            headerName: 'ETA', field: 'jobEta', width: 120, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ETD', field: 'jobEtd', width: 120, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ATD',
            colId: 'jobAtd',
            field: 'jobAtd',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          },
          {
            headerName: 'ATA',
            colId: 'jobAta',
            field: 'jobAta',
            width: 120,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('queryJob.route'),
            field: 'jobTransportLine',
            colId: 'jobTransportLine',
            valueFormatter: (params) => {
              return ColumnUtils.routeLabelFunctionForBill(params.data)
            },
            initialWidth: 200,
            hide: true
          }, {
            headerName: this.$t('SeaExport.ProjectName'),
            field: 'jobProjectName',
            colId: 'jobProjectName',
            hide: true,
            width: 150
          }, {
            headerName: this.$t('CargoMsg.Cargo_AccountPeriod'),
            field: 'creditDateLimited',
            colId: 'creditDateLimited',
            width: 100,
            hide: true,
            cellRenderer: params => ColumnUtils.AccountPeriodLabelFunc(params.data),
            filterParams: {},
            filterValueGetter: params => ColumnUtils.AccountPeriodLabelFunc(params.data)
          },
          {
            headerName: this.$t('queryJob.grossProfitRate'),
            suppressColumnsToolPanel: !this.showGrossProfit,
            hide: true,
            colId: 'grossProfit',
            field: 'grossProfit',
            width: 180,
            valueFormatter: (params) => {
              return params.data ? params.data.grossProfit : '0.00'
            }
          }, {
            headerName: this.$t('SeaExport.BookingAgent'),
            field: 'jobBookingAgent',
            colId: 'jobBookingAgent',
            hide: true,
            cellRenderer: (params) => {
              if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
                return ''
              }
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
            },
            initialWidth: 200
          },
          {
            headerName: this.$t('CargoMsg.Cargo_LinesArAp'), field: 'lineNumber', width: 100
          }, {
            headerName: this.$t('CargoMsg.Cargo_RInPay'), field: 'arIncludeAp', width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.IsBookedLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100
          },
          {
            headerName: this.$t('SeaExport.BillExchangeAgent'),
            field: 'exChangeAgent',
            colId: 'exChangeAgent',
            hide: true,
            cellRenderer: (params) => {
              if (params.data && (params.data.jobLob === SystemConstants.SI.code || params.data.jobLob === SystemConstants.AI.code)) {
                return params.data.jobBookingAgent ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.data.jobBookingAgent, 'auto_1') : ''
              }
              return params.value ? CustomLableUtils.getLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'auto_1') : ''
            },
            initialWidth: 200
          }
        ]
      } else {
        list = [
          {
            headerName: '',
            width: 55,
            checkboxSelection: true,
            sortable: false,
            suppressMenu: true,
            suppressSizeToFit: true,
            resizable: false,
            headerCheckboxSelection: true,
            lockVisible: true
          },
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'chargeWhtTaxLocalAmount',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('FinanceManage.charge_notWhtAmount'),
            field: 'chargeNotWhtAmount',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          }, {
            headerName: this.$t('FinanceManage.charge_whtTaxRate'),
            field: 'chargeWhtTaxRate',
            width: 100,
            hide: !this.showWhtTax,
            suppressColumnsToolPanel: !this.showWhtTax,
            valueFormatter: (params) => {
              return this.$numeral(params.value).format('0.00')
            }
          },
          {
            headerName: this.$t('Payment.businessNumber'),
            field: 'jobJobNo',
            width: 200,
            cellRendererFramework: 'agGridColumnEdit',
            custom: {
              tag: 'router-and-print',
              attrs: params => {
                const data = params.data
                return getJumpFinaceOrBusinessAttrs(true, false, data.jobJobNo, data.jobLob, data.chargeBranchId)
              }
            },
            onCellClicked: (params) => {
              if (params.event.target.tagName === 'A') {
                this.cancel()
              }
            }
          },
          {
            headerName: this.$t('Payment.settlementCompany'),
            field: 'chargeAccountId',
            width: 200,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('Payment.businessDate'),
            field: 'jobBusinessDate',
            width: 150,
            cellRenderer: params => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: this.$t('Payment.chargeItem'),
            field: 'chargeChargeItemId',
            width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
            }
          },
          {
            headerName: this.$t('Payment.currency'),
            field: 'chargeCurrency',
            width: 100
          },
          {
            headerName: this.$t('Payment.paymentType'),
            field: 'chargeReceivable',
            width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.chargeReceivableLabelFun(params.value)
            }
          },
          { headerName: this.$t('Insurance.InvoiceNumber'), field: 'chargeInvoiceNo', width: 150 },
          {
            headerName: this.$t('Payment.taxIncludedPrice'),
            field: 'chargeAmount',
            width: 150,
            cellRenderer: (params) => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxExcludedPrice'),
            field: 'chargeExcludingTaxAmount',
            width: 150,
            cellRenderer: (params) => {
              return formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxAmount'),
            field: 'chargeTaxAmount',
            width: 150,
            cellRenderer: (params) => {
              return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
            }
          },
          {
            headerName: this.$t('Payment.taxRate'),
            field: 'chargeTaxRate',
            width: 150,
            cellRenderer: (params) => {
              return params.value === 0 ? '' : formatNumberToThousands(params.value, 2)
            }
          },
          { headerName: this.$t('Payment.chargeRemark'), field: 'chargeRemarks', width: 200 },
          {
            headerName: 'ATD', field: 'jobAtd', width: 120, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          },
          {
            headerName: 'ATA', field: 'jobAta', width: 120, hide: true,
            cellRenderer: (params) => {
              return ColumnUtils.dateLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('FinanceManage.charge_payReceiveDate'),
            colId: 'chargePayReceiveDate',
            field: 'chargePayReceiveDate',
            width: 180,
            valueFormatter: params => {
              return DateUtils.formatStandardDate(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('FinanceManage.charge_writeOffDate'),
            colId: 'chargeClearingDate',
            field: 'chargeClearingDate',
            width: 180,
            valueFormatter: params => {
              return DateUtils.formatStandardDate(params.value)
            },
            hide: true
          }, {
            headerName: this.$t('Payment.mbl'),
            field: 'jobMbl',
            width: 150
          },
          {
            headerName: this.$t('queryJob.grossProfitRate'),
            hide: true,
            colId: 'grossProfit',
            field: 'grossProfit',
            width: 180,
            valueFormatter: (params) => {
              return params.data ? params.data.grossProfit : '0.00'
            }
          },
          {
            headerName: this.$t('queryJob.sales'),
            field: 'salesId',
            hide: true,
            width: 180,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_LinesArAp'), field: 'lineNumber', width: 100
          }, {
            headerName: this.$t('CargoMsg.Cargo_RInPay'), field: 'arIncludeAp', width: 100,
            cellRenderer: (params) => {
              return ColumnUtils.IsBookedLabelFunc(params.value)
            }
          }, {
            headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100
          },
          {
            headerName: this.$t('Payment.exchangeRate'),
            field: 'chargeExchangeRate',
            hide: true,
            width: 180,
            cellRenderer: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 8)
            }
          }
        ]
      }
      if (this.isSpecialExpenseEntryFunction) {
        list.push({
          headerName: this.$t('CargoMsg.Cargo_GrossProfitAmount'),
          colId: 'grossProfitAmount',
          field: 'grossProfitAmount',
          hide: true,
          initialWidth: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableTotal'),
          colId: 'specialChargeApSum',
          field: 'specialChargeApSum',
          hide: true,
          initialWidth: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialExpensePayableCurrency'),
          colId: 'specialChargeApCurrency',
          field: 'specialChargeApCurrency',
          hide: true,
          initialWidth: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableTotal'),
          colId: 'specialChargeArSum',
          field: 'specialChargeArSum',
          hide: true,
          initialWidth: 100
        }, {
          headerName: this.$t('CargoMsg.Cargo_SpecialExpenseReceivableCurrency'),
          colId: 'specialChargeArCurrency',
          field: 'specialChargeArCurrency',
          hide: true,
          initialWidth: 100
        })
      }
      return list
    },
    showRateByCharge() { // 显示按费用汇率创建
      return this.billPayment.currency === 'RMB'
    },
    exchangeRatePrecision() {
      return CurrencyUtil.getCurrencyRateDigits(this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : this.billPayment.currency)
    },
    rate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency1)
    },
    rate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency2)
    },
    rate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billPayment.currency3)
    },
    chargeCurrencySet() {
      return new Set(this.rowData.map(item => item.chargeCurrency))
    },
    ifHistoryPayment() {
      if (!this.billPayment.uuid) {
        return false
      }
      let ifHistory = true
      for (let i = 1; i <= 3; i++) {
        ifHistory = ifHistory && !this.billPayment['currency' + i]
      }
      return ifHistory
    },
    ifJc() {
      return this.viewSource === 'JC'
    }
  },
  watch: {
    // 付款申请单状态
    'billPayment.state': {
      handler: function(val) {
        const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(!val ? 0 : val))
        this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      },
      deep: true
    },
    //  结算代理
    'billPayment.settlementAgentId': {
      handler: function(val) {
        // 是否勾选结算代理复选框
        this.agentChecked = !!val
      },
      deep: true
    },
    // 结算对象
    'billPayment.accountId': {
      handler: function(val) {
        if (val > 0) {
          if (this.billPayment.settlementAgentId > 0) {
            const settlementAgent = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(this.billPayment.settlementAgentId))
            if (settlementAgent) {
              this.queryTitleBankList(Number(settlementAgent.cmpIdx))
            }
          } else {
            // 获取结算对象的开票抬头(一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行)
            this.queryTitleBankList(Number(val))
          }
          // 查询结算代理
          this.querySettlementAgentList(val)
        }
      },
      deep: true
    },
    // 分公司
    'billPayment.branchId': {
      handler: function(val) {
        if (val > 0) {
          const office = getObjectByCache(basicCacheKeys.basic_data_Office, 'officeId', Number(val))
          if (office) {
            const deps = getCacheListByKey(basicCacheKeys.basic_data_Department)
            if (deps && deps.length > 0) {
              this.departmentArray = deps.filter(dep => dep.officeUuid === office.uuid && (dep.jobNoPrefix && dep.jobNoPrefix !== ''))
            } else {
              this.departmentArray = []
            }
          }
        }
      },
      deep: true
    },
    // REQ-0033：付款类型/当前公司任一变化即重取后端清洗配置（原 enterpriseWechatTemplateUuid watch 语义平移）
    wechatFormConfigTrigger: {
      immediate: true,
      handler: function() {
        // 仅当付款类型已选时取企微字段配置并设置默认水单通知人
        const paymentType = this.billPayment && this.billPayment.paymentType
        if (paymentType !== undefined && paymentType !== null && paymentType !== '') {
          this.loadEnterpriseWechatFormConfig()
          this.setDefaultWaterNotifier()
        }
      }
    },
    // 企微「付款公司」变更时，自动匹配我方发票抬头（系统维护：发票抬头-企微审批付款公司）。
    // 本 watcher 覆盖回显/初始化等程序化赋值：未匹配时保留已有我方抬头（keepWhenUnmatched）；
    // 用户在企微字段中主动切换付款公司由 mixin 选择回调直调（keepWhenUnmatched: false，未匹配清空）
    'billPayment.paymentCompany': {
      immediate: true,
      handler: function(val) {
        this.syncOurTitleByPaymentCompany(val, { keepWhenUnmatched: true })
      }
    },
    'billPayment.rate': {
      immediate: true,
      handler: function(val) {
        if (!val || val === 0) {
          this.currencyChange(this.billPayment.currency)
        }
      }
    },
    billPaymentUuid: {
      immediate: true,
      handler: function(val) {
        this.curBillPaymentUuid = val
      }
    }
  },
  async created() {
    this.language = this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    await cache.load(cacheName.CONFIG)
    await this.initConfig()
    await this.initCustomFields()
    await this.initTitles()
  },
  beforeMount() {
    // 初始化保存按钮状态
    this.btnSaveEnable = false
    this.canUseBillingRate = false
    this.billCurrencyList = []
    const curBillPaymentUuid = this.curBillPaymentUuid
    if (curBillPaymentUuid) { // 查看编辑付款申请单
      this.queryBillPayment(curBillPaymentUuid)
    }
  },
  methods: {
    invoiceTitleChange(p) {
      const value = p && typeof p === 'object' ? p.value : p
      this.billPayment.invoiceTitle = value || ''
      this.titleBankArray = this.filterTitleBankArrayByInvoiceTitleAndCurrency(this.allTitleBankCache, this.billPayment.invoiceTitle, this.billPayment.currency)
      this.syncTitleBankSelection({ resetSelection: true })
      this.syncBuyerBankAccountSelection()
    },
    filterTitleBankArrayByInvoiceTitleAndCurrency(allTitleBanks, invoiceTitle, currency) {
      const title = typeof invoiceTitle === 'string' ? invoiceTitle.trim() : invoiceTitle
      const cur = typeof currency === 'string' ? currency.trim() : currency
      const banks = Array.isArray(allTitleBanks) ? allTitleBanks : []
      return banks.filter(row => {
        if (!row) return false
        if (title && (!row.title || row.title.title !== title)) return false
        if (cur && row.currency !== cur) return false
        return true
      })
    },
    syncTitleBankSelection({ resetSelection = false } = {}) {
      if (!this.billPayment) return
      if (this.titleBankArray && this.titleBankArray.length > 0) {
        if (resetSelection) {
          const defaultRow = this.titleBankArray.find(row => row && row.defaultBank) || this.titleBankArray[0]
          this.billPayment.buyerBank = defaultRow.bank || ''
          this.billPayment.buyerBankAccount = defaultRow.bankAccount || ''
          this.syncBuyerBankAccountSelection()
          return
        }
        const hasMatch = this.titleBankArray.find(item => item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount)
        if (!hasMatch) {
          const sameBankRows = this.billPayment.buyerBank
            ? this.titleBankArray.filter(row => row && row.bank === this.billPayment.buyerBank)
            : []
          const fallbackList = sameBankRows.length > 0 ? sameBankRows : this.titleBankArray
          const defaultRow = fallbackList.find(row => row && row.defaultBank) || fallbackList[0]
          this.billPayment.buyerBank = defaultRow.bank || ''
          this.billPayment.buyerBankAccount = defaultRow.bankAccount || ''
          this.syncBuyerBankAccountSelection()
        }
      } else if (resetSelection) {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
      }
    },
    syncBuyerBankAccountSelection() {
      if (!this.billPayment) return
      const list = this.buyerBankAccountArray
      if (list && list.length > 0) {
        const hasMatch = list.find(item => item && item.bankAccount === this.billPayment.buyerBankAccount)
        if (!hasMatch) {
          this.billPayment.buyerBankAccount = list[0].bankAccount || ''
        }
      } else if (this.billPayment.buyerBankAccount) {
        // 当切换银行/抬头/币种后无匹配账号时，清空，避免提交不一致的数据
        this.billPayment.buyerBankAccount = ''
      }
    },
    buyerBankAccountChange(p) {
      if (p) {
        const value = p && typeof p === 'object' ? (p.value || p.bankAccount) : p
        this.billPayment.buyerBankAccount = value ? String(value) : ''
      } else {
        this.billPayment.buyerBankAccount = ''
      }
    },
    // 初始化自定义字段
    async initCustomFields() {
      const res = await getCustomFieldList({ fieldDisplay: SystemConstants.FIELD_DISPLAY_PAYMENT_REQUEST_MODULE.code })
      if (res.data.list && res.data.list.length > 0) {
        this.customFields = res.data.list.sort((a, b) => a.fieldCode - b.fieldCode)
        this.customFields.forEach(obj => {
          if (obj.enumStr) {
            obj.enums = obj.enumStr.split(',').map(p => {
              return { 'tagName': p, 'tagValue': p }
            })
          }
          const value = this.billPayment[SystemConstants.CUSTOM_FIELDS_PAYMENT_REQUEST_MAP.get(obj.fieldCode)]
          if (obj.enums && obj.enums.length > 0) {
            const row = obj.enums.find(p => p.tagValue === value)
            if (!row) {
              obj.enums.push({ 'tagName': value, 'tagValue': value, notShowInOptions: true })
            }
          } else {
            obj.enums = [{ 'tagName': value, 'tagValue': value, notShowInOptions: true }]
          }
        })
      }
    },
    initTitles() {
      // 获取发票抬头列表
      this.getInvoiceTitlesByOfficeCache.execute({ officeId: this.$store.getters.currentOfficeId }).then(res => {
        this.ourInvoiceTitleArray = res.data
        const value = this.billPayment.ourTitle
        if (this.ourInvoiceTitleArray && this.ourInvoiceTitleArray.length > 0) {
          const row = this.ourInvoiceTitleArray.find(p => p.tagValue === value || p.invoiceTitle === value)
          if (!row) {
            this.ourInvoiceTitleArray.push({ invoiceTitle: value, tagValue: value, notShowInOptions: true })
          }
        } else {
          this.ourInvoiceTitleArray = [{ invoiceTitle: value, tagValue: value, notShowInOptions: true }]
        }
        // 企微付款公司可能已存在（编辑/反显场景），此处拿到抬头列表后补做一次自动匹配；
        // 初始化补做未匹配时保留已保存的我方抬头（用户切换付款公司由 mixin 回调直调，允许清空）
        this.syncOurTitleByPaymentCompany(this.billPayment && this.billPayment.paymentCompany, { keepWhenUnmatched: true })
      })
    },
    syncOurTitleByPaymentCompany(paymentCompany, { keepWhenUnmatched = false } = {}) {
      if (!this.billPayment) return
      const company = typeof paymentCompany === 'string' ? paymentCompany.trim() : ''
      // paymentCompany 为空时不改动我方抬头：
      // 1) 避免页面首次加载/反显时（抬头列表未加载或付款公司未选择）误清空已有 ourTitle
      // 2) 允许用户在未选择付款公司时手动选择我方抬头
      if (!company) return

      const titles = Array.isArray(this.ourInvoiceTitleArray) ? this.ourInvoiceTitleArray : []
      // 抬头列表未加载完成前无法匹配，等待 initTitles() 拿到列表后再次调用本方法
      if (titles.length === 0) return

      const matched = titles.find(row => {
        const wechatPayCompany = row && typeof row.enterpriseWechatPayCompany === 'string' ? row.enterpriseWechatPayCompany.trim() : ''
        return wechatPayCompany && wechatPayCompany === company
      })
      if (!matched) {
        // keepWhenUnmatched=true：回显/初始化场景，抬头主数据未维护映射时保留已保存的
        // ourTitle，避免每次打开详情被清空；用户主动切换付款公司走默认 false，未匹配清空
        if (!keepWhenUnmatched) {
          this.billPayment.ourTitle = ''
        }
        return
      }

      const targetTitle = matched.invoiceTitle || matched.tagValue || ''
      if (targetTitle && this.billPayment.ourTitle !== targetTitle) {
        this.billPayment.ourTitle = targetTitle
      }
    },
    async initConfig() {
      this.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
    },
    // 初始化付款申请
    async initBillPayment(charges = []) {
      this.activeTabName = 'applicationForm'
      if (!charges || charges.length === 0) return
      const billPayment = new BillPayment().fillDefaultValue().getData()
      this.rowData = charges
      this.rowData.forEach(e => {
        if (!e.chargeBillUuid) {
          e.chargeBillUuid = e.billingUuid
        }
      })
      const charge = charges[0]
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.inputBy = this.$store.getters.userInfo.userId
      billPayment.inputDate = new Date()
      billPayment.accountId = charge.chargeAccountId
      billPayment.state = 0
      billPayment.paymentType = '0'
      billPayment.syncInvoiceAttachment = true
      const state = CommonState.getStateByCode(ClearingConstants.BILL_PAYMENT_STATES, Number(billPayment.state))
      this.stateText = this.$store.getters.language === 'zh' ? state.chineseName : state.englishName
      billPayment.se = false
      billPayment.si = false
      billPayment.ae = false
      billPayment.ai = false
      billPayment.ri = false
      billPayment.re = false
      billPayment.ie = false
      billPayment.fba = false
      this.jobTypes = []
      for (const charge of charges) {
        this.addLob(charge, billPayment, SystemConstants.BILL_PAYMENT_LOBS)
      }
      billPayment.currency = charge.chargeCurrency
      // 付款方式默认为银行转账
      billPayment.payType = 2
      if (LocalStorageUtilsNew.hasConfiguration('billPaymentFormPage')) {
        const item = LocalStorageUtilsNew.getConfiguration('billPaymentFormPage')
        billPayment.paymentType = item.paymentType
        billPayment.ourTitle = item.ourTitle
      }
      this.billPayment = billPayment
      this.querySettlementAgentList(billPayment.accountId)
      await this.getChargeBillingMultiCurrencyInfo()
      this.currencyChange(billPayment.currency)
      this.calCurrencyAmount()
      this.checkChargeSameTitle()
      this.getTitleArrayJc()
    },
    ourTitleChangeEvent(p) {
      if (p) {
        this.billPayment.ourTitle = p.value
      } else {
        this.billPayment.ourTitle = ''
      }
    },
    addLob(charge, billPayment, lobs) {
      // 先判断是否fba
      if (charge.fba) {
        billPayment['fba'] = true
        if (this.jobTypes.indexOf('FBA') < 0) {
          this.jobTypes.push('FBA')
        }
        return
      }
      for (const state of lobs) {
        const lob = state.code
        if (charge.jobLob && charge.jobLob === lob) {
          billPayment[lob.toLowerCase()] = true
          if (this.jobTypes.indexOf(lob) < 0) {
            this.jobTypes.push(lob)
          }
          return
        }
      }
    },
    // 查询付款申请
    queryBillPayment(curBillPaymentUuid = null) {
      queryBillPaymentDetail({
        billPaymentUuid: curBillPaymentUuid,
        paging: false,
        branchId: this.$store.getters.currentOfficeId
      }).then(res => {
        this.billPayment = res.data
        if (this.billPayment.se) {
          this.jobTypes.push('SE')
        }
        if (this.billPayment.si) {
          this.jobTypes.push('SI')
        }
        if (this.billPayment.ae) {
          this.jobTypes.push('AE')
        }
        if (this.billPayment.ai) {
          this.jobTypes.push('AI')
        }
        if (this.billPayment.ri) {
          this.jobTypes.push('RI')
        }
        if (this.billPayment.re) {
          this.jobTypes.push('RE')
        }
        if (this.billPayment.ie) {
          this.jobTypes.push('IE')
        }
        if (this.billPayment.fba) {
          this.jobTypes.push('FBA')
        }
        this.queryChargeOfBillPayment(this.billPayment.uuid)
        this.getTitleArrayJc()
      })
    },
    // 查询付款申请单关联的费用
    queryChargeOfBillPayment(curBillPaymentUuid = null) {
      this.loading = getLoading4Cxt()
      const requestBody = {
        billPaymentUuid: curBillPaymentUuid,
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        branchId: this.$store.getters.currentOfficeId
      }
      queryChargeOfBillPayment(requestBody).then(async res => {
        this.rowData = res.data.list ? res.data.list : []
        this.pagination.total = Number(res.data.total)
        this.refreshChargeNotWhtAmount()
        await this.getChargeBillingMultiCurrencyInfo()
        await this.initMultiCurrencyRate()
        await this.rateLabelChange(this.billPayment.currency, this.rowData, false)
      }).finally(() => {
        this.loading.close()
      })
    },
    queryJobOfBillPayment(curBillPaymentUuid = null) {
      this.loading = getLoading4Cxt()
      const requestBody = { billPaymentUuid: curBillPaymentUuid, pageNum: this.pagination.pageNum, pageSize: this.pagination.pageSize, branchId: this.$store.getters.currentOfficeId }
      this.rowData = []
      queryJobOfBillPayment(requestBody).then(async res => {
        if (res.data.list && res.data.list.length > 0) {
          this.rowData = [...res.data.list]
        } else {
          this.rowData = []
        }
      }).finally(() => {
        this.loading.close()
      })
    },
    // 获取各费用账单币种与汇率对应关系
    async getChargeBillingMultiCurrencyInfo() {
      this.billingList = []
      this.canUseBillingRate = false
      const noBillCharge = this.rowData.find(item => !item.chargeBillUuid && !item.billingUuid)
      if (!noBillCharge && this.rowData && this.rowData.length > 0) {
        await getChargeBillingMultiCurrencyInfo([...new Set(this.rowData.map(item => item.chargeBillUuid))]).then(res => {
          if (res.ok) {
            this.billingList = res.data
          }
        }).catch(() => {
        })
        this.canUseBillingRate = this.ifBillCurrencySameAsPayment()
      }
      // 判断是否可以保持按账单汇率付款状态（如新增/删除 已有账单/无账单费用）
      this.billPayment.payByBillingRate = this.billPayment.payByBillingRate && this.canUseBillingRate
    },
    ifBillCurrencySameAsPayment(currency = '') {
      let same = false
      if (this.billingList && this.billingList.length > 0) {
        let billCurrency = this.billingList[0].currency
        for (const bill of this.billingList) {
          if (bill.currency !== billCurrency) {
            billCurrency = ''
            break
          }
        }
        same = billCurrency === (currency || this.billPayment.currency)
      }
      return same
    },
    async payByBillingRateChanged() {
      if (this.billPayment.payByBillingRate && this.billPayment.rateByCharge) {
        this.billPayment.rateByCharge = false
      }
      await this.initMultiCurrencyRate(true)
      this.refreshAmount()
    },
    // 初始化币种与汇率对应关系
    async initMultiCurrencyRate(changeRate = false) {
      const charges = this.rowData
      this.currencyRateMap = {}
      this.billCurrencyList = []
      if (changeRate) {
        for (let i = 1; i <= 3; i++) {
          this.billPayment['currency' + i] = ''
          this.billPayment['rate' + i] = 0
        }
      }
      // 所有费用都开过账单，校验各账单币种与付款申请币种是否相同
      const useBill = this.ifBillCurrencySameAsPayment()
      // 使用账单币种
      if (this.billPayment.payByBillingRate && useBill) {
        // key为币种，value为同币种汇率列表，方便后续算平均值
        const billCurrencyRateListMap = {}
        for (const bill of this.billingList) {
          for (let i = 1; i <= 3; i++) {
            const currency = bill['sourceCurrency' + i]
            const rate = bill['sourceRate' + i]
            if (currency && rate) {
              let rateList = billCurrencyRateListMap[currency]
              if (rateList && rateList.length > 0) {
                rateList.push(Number(rate))
              } else {
                rateList = []
                rateList.push(Number(rate))
              }
              billCurrencyRateListMap[currency] = rateList
            }
          }
        }
        let multiIdx = 1
        for (const currency of this.chargeCurrencySet) {
          this.billCurrencyList.push(currency)
          if (billCurrencyRateListMap.hasOwnProperty(currency)) {
            const rateList = billCurrencyRateListMap[currency]
            let rateSum = 0
            for (const rate of rateList) {
              rateSum += rate
            }
            const rateAve = NumberUtils.ToFixed2(rateList.length === 1 ? rateSum : rateSum / rateList.length, 8)
            if ((!this.billPayment['currency' + multiIdx] && !this.billPayment.uuid) || changeRate) {
              this.billPayment['currency' + multiIdx] = currency
            }
            if ((!this.billPayment['rate' + multiIdx] && !this.billPayment.uuid) || changeRate) {
              this.billPayment['rate' + multiIdx] = rateAve
            }
            multiIdx++
          }
        }
      } else {
        // 使用费用币种
        if (charges && charges.length > 0) {
          let multiIdx = 1
          for (const currency of this.chargeCurrencySet) {
            if ((!this.billPayment['currency' + multiIdx] && !this.billPayment.uuid) || changeRate) {
              this.billPayment['currency' + multiIdx] = currency
            }
            if ((!this.billPayment['rate' + multiIdx] && !this.billPayment.uuid) || changeRate) {
              this.billPayment['rate' + multiIdx] = RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, currency, new Date(), this.billPayment.branchId)
            }
            multiIdx++
          }
        }
      }
      for (let i = 1; i <= 3; i++) {
        this.currencyRateMap[this.billPayment['currency' + i]] = this.billPayment['rate' + i]
      }
    },
    // 汇率标题修改事件
    async rateLabelChange(currency = '', charges = [], changeRate = false) {
      if (currency && charges && charges.length > 0) {
        const otherCurrencyArray = []
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          if (chargeCurrency && chargeCurrency !== this.billPayment.currency && otherCurrencyArray.indexOf(chargeCurrency) < 0) {
            otherCurrencyArray.push(chargeCurrency)
          }
        }
        if (otherCurrencyArray.length > 0) {
          this.rateLabel = otherCurrencyArray[0] + this.$t('Payment.exchangeRate')
          if (changeRate) {
            this.billPayment.rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, otherCurrencyArray[0], new Date(), this.billPayment.branchId)
          }
        } else {
          this.rateLabel = this.$t('Payment.exchangeRate')
          this.billPayment.rate = 1.000000
        }
        this.otherCurrencyArray = otherCurrencyArray
      }
    },
    // 费用列表分页事件
    queryPageHandler() {
      if (this.curBillPaymentUuid) {
        this.queryChargeOfBillPayment(this.curBillPaymentUuid)
      }
    },
    async querySettlementAgentList(accountId) {
      const settlementAgentArray = await getSettlementAgentsByCmpIdx(accountId).then((res) => {
        return res.data
      })
      if (settlementAgentArray && settlementAgentArray.length > 0) {
        this.settlementAgentArray = settlementAgentArray
      } else {
        this.settlementAgentArray = []
      }
    },
    // 查询开户银行
    queryTitleBankList(accountId) {
      if (accountId > 0) {
        allTitleBanksByCmpIdx(accountId).then((res) => {
          if (res.data && res.data.length > 0 || (this.billPayment.buyerBank !== null && this.billPayment.buyerBank !== '')) {
            this.allTitleBankCache = Array.isArray(res.data) ? res.data : []
            this.titleBankArray = this.filterTitleBankArrayByInvoiceTitleAndCurrency(this.allTitleBankCache, this.billPayment.invoiceTitle, this.billPayment.currency)
            this.syncTitleBankSelection()
            if (!this.allTitleBankCache.find(item => item.bank === this.billPayment.buyerBank && item.bankAccount === this.billPayment.buyerBankAccount)) {
              this.allTitleBankCache.push({ bank: this.billPayment.buyerBank, uuid: this.billPayment.uuid, bankAccount: this.billPayment.buyerBankAccount, currency: this.billPayment.currency, title: { title: this.billPayment.invoiceTitle }})
              this.titleBankArray = this.filterTitleBankArrayByInvoiceTitleAndCurrency(this.allTitleBankCache, this.billPayment.invoiceTitle, this.billPayment.currency)
            }
            if (!this.billPayment.uuid) { // 新增时
              for (const titleBank of this.titleBankArray) {
                if (titleBank.defaultBank && titleBank.title && titleBank.title.defaultTitle) {
                  this.billPayment.buyerBank = titleBank['bank']
                  this.billPayment.buyerBankAccount = titleBank['bankAccount']
                  break
                }
              }
            } else {
              for (const titleBank of this.titleBankArray) {
                if (titleBank.bank === this.billPayment.buyerBank && titleBank.bankAccount === this.billPayment.buyerBankAccount) {
                  break
                }
              }
            }
          } else {
            this.allTitleBankCache = []
            this.titleBankArray = []
            this.billPayment.buyerBank = ''
            this.billPayment.buyerBankAccount = ''
          }
        })
      }
    },
    // 结算对象变更事件
    accountChange(accountId) {
      if (!this.agentChecked && accountId) {
        this.queryTitleBankList(accountId)
      }
    },
    // 结算代理勾选框变更事件
    cbSettlementAgentChange() {
      if (this.agentChecked) {
        if (this.billPayment.settlementAgentId) {
          this.queryTitleBankList(this.billPayment.settlementAgentId)
        }
      } else {
        this.billPayment.settlementAgentId = 0
        if (this.billPayment.accountId) {
          this.queryTitleBankList(this.billPayment.accountId)
        }
      }
    },
    // 结算代理变更事件
    settlementAgentChange() {
      if (this.agentChecked && this.billPayment.settlementAgentId) {
        this.queryTitleBankList(this.billPayment.settlementAgentId)
      }
    },
    // 币种变更事件
    async currencyChange(currency = null, isUserChange = false) {
      if (currency && currency !== 'RMB') {
        this.billPayment.rateByCharge = false
      }
      const noBillCharge = this.rowData.find(item => !item.chargeBillUuid && !item.billingUuid)
      if (!noBillCharge) {
        this.canUseBillingRate = this.ifBillCurrencySameAsPayment(currency)
      }
      if (currency) {
        this.billPayment.currency = currency
        await this.initMultiCurrencyRate(true)
        await this.rateLabelChange(currency, this.rowData, true)
        this.refreshAmount()
        this.refreshChargeNotWhtAmount()
        // 用户切换币种时重新查询合作伙伴银行（参照 CARGO-50234），避免本地数据缺失或过期导致银行账号不联动
        if (isUserChange) {
          await this.reloadTitleBankCache()
        }
        this.titleBankArray = this.filterTitleBankArrayByInvoiceTitleAndCurrency(this.allTitleBankCache, this.billPayment.invoiceTitle, this.billPayment.currency)
        this.syncTitleBankSelection()
        this.syncBuyerBankAccountSelection()
      }
    },
    // 按结算对象/结算代理重新拉取开户行完整数据源
    async reloadTitleBankCache() {
      const bankAccountId = this.agentChecked && this.billPayment.settlementAgentId > 0
        ? this.billPayment.settlementAgentId
        : this.billPayment.accountId
      if (!(bankAccountId > 0)) return
      await allTitleBanksByCmpIdx(bankAccountId).then(res => {
        if (res && res.data && res.data.length > 0) {
          this.allTitleBankCache = res.data
        }
      }).catch(() => {
      })
    },
    // 结算公司变更事件
    settleDepartmentPrefixChange(dep) {
      if (dep) {
        this.billPayment.settleDepartmentPrefix = dep.jobNoPrefix ? dep.jobNoPrefix : ''
      } else {
        this.billPayment.settleDepartmentPrefix = ''
      }
    },
    currencyRateChanged(rate, currencyLabel) {
      this.currencyRateMap[this.billPayment[currencyLabel]] = Number(rate)
      this.refreshAmount()
    },
    async rateByChargeChanged() {
      if (this.billPayment.payByBillingRate && this.billPayment.rateByCharge) {
        this.billPayment.payByBillingRate = false
      }
      if (!this.ifHistoryPayment && !this.billPayment.rateByCharge) {
        await this.initMultiCurrencyRate(true)
      }
      this.refreshAmount()
    },
    // 刷新付款申请单金额
    async refreshAmount() {
      let amount = 0
      if (this.rowData && this.rowData.length > 0) {
        // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
        const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.rowData, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
        for (const charge of this.rowData) {
          if (amountCurrencys.includes(charge.chargeCurrency)) continue
          let rate = 1
          if (this.billPayment.rateByCharge && this.showRateByCharge) {
            rate = charge.chargeExchangeRate
          } else {
            // CARGO-39011 付款申请支持三币种
            if (this.ifHistoryPayment) {
              if (charge.chargeCurrency === this.billPayment.currency) {
                rate = 1
              } else if (charge.chargeCurrency === this.otherCurrencyArray[0]) {
                rate = isNaN(this.billPayment.rate) ? 0.00 : this.billPayment.rate
              } else {
                rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, charge.chargeCurrency, new Date(), this.billPayment.branchId)
              }
            } else {
              rate = this.currencyRateMap[charge.chargeCurrency]
            }
          }
          charge.chargeRate = rate
          // CARGO-30308 ID：1887 烽沛 付款申请金额与开票金额相差0.01
          if (charge.chargeReceivable) {
            // amount -= charge.chargeAmount * rate
            amount -= RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
          } else {
            // amount += charge.chargeAmount * rate
            amount += RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
          }
        }
      }
      // this.billPayment.amount = NumberUtils.ToFixed2(amount, 2)
      this.billPayment.amount = NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(amount, this.billPayment.currency), 2)
    },
    refreshChargeNotWhtAmount() {
      let amount = 0.00
      if (this.rowData && this.rowData.length > 0 && this.showWhtTax) {
        for (const charge of this.rowData) {
          amount += charge.chargeNotWhtAmount || 0.00
        }
        this.billPayment.chargeNotWhtAmount = NumberUtils.ToFixed2(amount, 2)
      }
    },
    rateVerify() {
      if (!this.billPayment.rate || this.billPayment.rate === 0) {
        this.currencyChange(this.billPayment.currency)
      }
    },
    // 汇率变更事件
    rateChange() {
      this.refreshAmount()
    },
    // 开户银行变更事件
    titleBankChange(titleBank) {
      if (titleBank) {
        const prevBank = this.billPayment.buyerBank
        const bank = titleBank.value || titleBank.bank || ''
        this.billPayment.buyerBank = bank
        if (titleBank.bankAccount) {
          this.billPayment.buyerBankAccount = titleBank.bankAccount
        } else if (prevBank !== bank) {
          this.billPayment.buyerBankAccount = ''
        }
        this.syncBuyerBankAccountSelection()
      } else {
        this.billPayment.buyerBank = ''
        this.billPayment.buyerBankAccount = ''
      }
    },
    // 加入费用
    async addCharge() {
      const keys = []
      if (this.rowData && this.rowData.length > 0) {
        for (const charge of this.rowData) {
          if (keys.indexOf(charge.uuid) < 0) {
            keys.push(charge.uuid)
          }
        }
      }
      this.joinChargeDialog.addChargeCondition.accountId = this.billPayment.accountId
      this.joinChargeDialog.addChargeCondition.hasBillPayment = 0
      this.joinChargeDialog.addChargeCondition.isShowWriteOff = 0
      this.joinChargeDialog.addChargeCondition.exceptKeys = keys
      this.joinChargeDialog.visible = true
    },
    // 加入费用回调函数
    async addChargeCallBack(charges = []) {
      if (charges && charges.length > 0) {
        let chargesAdded = this.billPayment.chargesAdded
        const chargesRemoved = this.billPayment.chargesRemoved
        for (const charge of charges) {
          // 1.判断添加费用的集合是否存在，不存在则初始化变量
          if (!chargesAdded) {
            chargesAdded = []
          }
          const index = chargesAdded.findIndex(p => p.uuid === charge.uuid)
          if (index < 0) {
            chargesAdded.push({ uuid: charge.uuid, version: charge.version })
          }
          // 2.校验新添加的费用是否在移除的费用中，有则移除
          if (chargesRemoved && chargesRemoved.length > 0) {
            const delIndex = chargesRemoved.findIndex(p => p.uuid === charge.uuid)
            if (delIndex > -1) {
              chargesRemoved.splice(delIndex, 1)
            }
          }
        }
        this.billPayment.chargesAdded = chargesAdded
        this.billPayment.chargesRemoved = chargesRemoved
        // 更新费用列表
        this.rowData = this.rowData.concat(charges)
        this.rowData.forEach(e => {
          if (!e.chargeBillUuid) {
            e.chargeBillUuid = e.billingUuid
          }
        })
        // 重新计算付款申请金额以及分币种合计
        await this.getChargeBillingMultiCurrencyInfo()
        this.currencyChange(this.billPayment.currency)
        this.calCurrencyAmount()
        this.joinChargeDialog.visible = false
      }
    },
    showInvoicePoolDialog() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      const invoicedCharge = chooseRows.find(row => this.hasAssociatedInvoice(row))
      if (invoicedCharge) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ChargeAlreadyAssociatedInvoice', [this.getChargeAssociationLabel(invoicedCharge)]))
        return
      }
      this.invoicePoolDialog.sellerTaxNameDefaultValue = chooseRows[0].chargeInvoiceTitle || chooseRows[0].invoiceTitle || ''
      this.invoicePoolDialog.selectedEntities = chooseRows
      this.invoicePoolDialog.source = 'invoice'
      this.invoicePoolDialog.operation = 'collection'
      this.invoicePoolDialog.makeInvoiceMethod = 1
      this.invoicePoolDialog.visible = true
    },
    hasAssociatedInvoice(row) {
      if (!row) return false
      return this.hasValue(row.invoiceUuid) || this.hasValue(row.chargeInvoiceUuid) || this.hasValue(row.invoiceNo) || this.hasValue(row.chargeInvoiceNo)
    },
    hasValue(value) {
      return value !== undefined && value !== null && String(value).trim() !== ''
    },
    getChargeAssociationLabel(row) {
      const jobNo = row.jobJobNo || row.jobNo || ''
      const chargeName = row.chargeName || row.chargeChargeName || row.chargeItemName || ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', row.chargeChargeItemId, 'zhName') || ''
      return `${jobNo}--${chargeName}`
    },
    async invoicePoolCallBack(invoices = []) {
      console.log('[BillPaymentByJob] invoicePoolCallBack', {
        invoiceCount: Array.isArray(invoices) ? invoices.length : 0,
        rowCount: Array.isArray(this.rowData) ? this.rowData.length : 0
      })
      await this.refreshChargesAfterInvoiceAssociation(invoices)
      this.invoicePoolDialog.selectedEntities = []
    },
    async refreshChargesAfterInvoiceAssociation(invoices = []) {
      const chargeUuids = [...new Set((this.rowData || []).map(item => item && item.uuid).filter(item => item))]
      console.log('[BillPaymentByJob] refreshChargesAfterInvoiceAssociation', {
        invoiceCount: Array.isArray(invoices) ? invoices.length : 0,
        rowCount: Array.isArray(this.rowData) ? this.rowData.length : 0,
        chargeUuids
      })
      if (chargeUuids.length === 0) {
        console.log('[BillPaymentByJob] skip loadChargeByUuids because chargeUuids is empty')
        return
      }
      console.log('[BillPaymentByJob] calling loadChargeByUuids', chargeUuids)
      const res = await loadChargeByUuids(chargeUuids)
      const latestCharges = Array.isArray(res.data) ? res.data : []
      console.log('[BillPaymentByJob] loadChargeByUuids resolved', {
        chargeCount: latestCharges.length
      })
      const latestVersionMap = latestCharges.reduce((map, charge) => {
        if (charge && charge.uuid) {
          map[charge.uuid] = charge.version
        }
        return map
      }, {})
      this.rowData = latestCharges
      if (this.billPayment && Array.isArray(this.billPayment.chargesRemoved) && this.billPayment.chargesRemoved.length > 0) {
        this.billPayment.chargesRemoved = this.billPayment.chargesRemoved.map(charge => {
          if (!charge || !charge.uuid || latestVersionMap[charge.uuid] === undefined) {
            return charge
          }
          return {
            ...charge,
            version: latestVersionMap[charge.uuid]
          }
        })
      }
      if (this.gridOptions && this.gridOptions.api) {
        this.gridOptions.api.refreshCells({ force: true })
      }
    },
    buildInvoiceByChargeUuid(invoices = []) {
      const invoiceByChargeUuid = {}
      invoices.forEach(invoice => {
        const charges = invoice.chargeList || invoice.charges || invoice.charge || []
        charges.forEach(charge => {
          const chargeUuid = charge.uuid || charge.chargeUuid
          if (chargeUuid) {
            invoiceByChargeUuid[chargeUuid] = invoice
          }
        })
      })
      return invoiceByChargeUuid
    },
    // 移除费用
    removeCharge() {
      const charges = this.rowData
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpense'))
        return
      }
      if (charges.length === chooseRows.length) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CanNotRemovedAllCharge'))
        return
      }
      this.$confirm(this.$t('CargoMsg.Cargo_SureToRemoveTheExpenseItem', [chooseRows.length]), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        for (const removedCharge of chooseRows) {
          const index = charges.findIndex(p => p.uuid === removedCharge.uuid)
          if (index > -1) {
            // 1.从费用明细列表中移除
            charges.splice(index, 1)
            // 2.是否有被移除的费用集合，没有则初始化变量
            if (!this.billPayment.chargesRemoved) {
              this.billPayment.chargesRemoved = []
            }
            const charge = {}
            charge.uuid = removedCharge.uuid
            charge.version = removedCharge.version
            // 3.先判断是否有进行过添加费用操作, 如果有，则移除掉。
            if (this.billPayment.chargesAdded && this.billPayment.chargesAdded.length > 0) {
              const addIndex = this.billPayment.chargesAdded.findIndex(p => p.uuid === charge.uuid)
              if (addIndex > -1) { // 如果有，则直接从chargesAdded移除
                this.billPayment.chargesAdded.splice(addIndex, 1)
              }
            }
            // 4. 判断删除的集合中是否包含本次移除的费用，如果没有，则添加到移除集合中。
            const delIndex = this.billPayment.chargesRemoved.findIndex(p => p.uuid === charge.uuid)
            if (removedCharge.billPaymentUuid) { // 已关联的付款申请
              if (delIndex < 0) {
                this.billPayment.chargesRemoved.push(charge)
              }
            } else { // 没有关联付款申请的，直接移除掉
              if (delIndex >= 0) {
                this.billPayment.chargesRemoved.splice(delIndex, 1)
              }
            }
          }
          await this.getChargeBillingMultiCurrencyInfo()
          this.currencyChange(this.billPayment.currency)
          this.calCurrencyAmount()
        }
      }).catch(() => {
      })
    },
    // 上一步
    toPreStep() {
      this.$emit('toPreStep', 'step1')
    },
    // 计算分币种合计
    calCurrencyAmount() {
      const charges = this.rowData
      let currencyAmount = ''
      if (charges && charges.length > 0) {
        const currencyMap = new Map()
        for (const charge of charges) {
          const chargeCurrency = charge.chargeCurrency
          const amount = isNaN(charge.chargeAmount) ? 0 : charge.chargeAmount
          const receivable = charge.chargeReceivable
          if (!receivable) {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + amount)
              currencyMap.set(chargeCurrency, RateUtil.getAmountByCurrency(total + amount, chargeCurrency))
            }
          } else {
            if (!currencyMap.has(chargeCurrency)) {
              currencyMap.set(chargeCurrency, -amount)
            } else {
              const total = currencyMap.get(chargeCurrency)
              // currencyMap.set(chargeCurrency, total + (-amount))
              currencyMap.set(chargeCurrency, RateUtil.getAmountByCurrency(total + (-amount), chargeCurrency))
            }
          }
        }
        currencyMap.forEach(function(value, key) {
          // currencyAmount += key + ':' + NumberUtils.formatNumber(NumberUtils.ToFixed2(value, 2), 2) + ';'
          currencyAmount += key + ':' + NumberUtils.formatNumber(NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(value, key), 2), 2) + ';'
        })
      }
      this.billPayment.currencyAmount = currencyAmount
    },
    // 打印按钮触发事件
    doPrint() {
      this.templateSelectorDialog.data.BILLPAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.data.BILL_PAYMENT_UUID = this.billPayment.uuid
      this.templateSelectorDialog.category = 'BILLPAYMENT'
      this.templateSelectorDialog.visible = true
    },
    // 办理按钮点击事件（与列表页一致：审批通过且未全部核销的付款申请才允许自动销账）
    processPaymentRequest() {
      const bp = this.billPayment
      if (!bp || !bp.uuid) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectPaymentApplication'))
        return
      }

      // state: 10=审批通过；realClearingState: 2=全部核销
      if (bp.state !== 10 || bp.realClearingState === 2) {
        this.$message.error(this.$t('CargoMsg.Cargo_OnlyApprovedAndNotFullyWrittenOffCanProcess'))
        return
      }

      this.$confirm(this.$t('CargoMsg.Cargo_ConfirmAutoWriteOffSelectedPaymentRequests'), this.$t('CargoMsg.Cargo_Tips'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        const loading = getLoading4Cxt(this)
        await autoBillPaymentWriteOffFunc([bp.uuid]).then(res => {
          if (res) {
            this.$message.success(this.$t('CargoMsg.Cargo_ProcessSuccessWrittenOff', [res.data || 0]))
            // 刷新详情 & 通知列表刷新
            this.queryBillPayment(bp.uuid)
            this.$emit('reloadData', { uuid: bp.uuid })
          }
        }).catch(err => {
          this.$message.error(err.message || this.$t('CargoMsg.Cargo_ProcessFailed'))
        }).finally(() => {
          loading.close()
        })
      }).catch(() => {
        // 取消操作
      })
    },
    // 取消事件
    cancel() {
      this.btnSaveEnable = false
      this.$emit('cancel')
    },
    // 提交按钮触发事件
    async doCommitPre() {
      if (this.commitSubmitting) return
      this.commitSubmitting = true

      if (this.billPayment.uuid && this.billPayment.version) {
        try {
          const saveSuccess = await this.doSavePre()
          if (!saveSuccess) {
            return
          }
          if (parseInt(cache.config.get('BPM_StartOldApproval')) === 0) {
            // 发起bpm审批
            this.workFlowApplyDialog.visible = true
            return
          }
          // 专项付款申请类型时校验付款申请费用和毛利两倍差额审批
          if (this.billPayment.paymentType === '1') {
            const company = await Company.getCompanyById(this.billPayment.accountId)
            if (company) {
              const data = await checkBillPaymentJobSettleFunc({ billPaymentKey: this.billPayment.uuid, checkSpecial: company.specialFeePaymentLimit }).then(res => res.data)
              const settleCheck = normalizeBillPaymentJobSettleCheck(data)
              if (settleCheck.applyStatus === 'NEED_APPROVAL') {
                this.specialDialog.applyReason = settleCheck.applyReason || ''
                this.specialDialog.visible = true
                return
              } else if (settleCheck.applyStatus === 'NOT_SETTLE') {
                // 应收费用未结清
                this.$message.warning(this.$t('CargoMsg.Cargo_ThePaymentNotSettled', [settleCheck.applyReason]))
                return
              }
            }
          }

          // 0 无票，1 有票
          this.billPayment.lackInvoiceFlag = await this.isLackInvoice()
          if (this.billPayment.lackInvoiceFlag === 0 && this.billPayment.paymentType === '0') {
            try {
              await this.$confirm(this.$t('Message.lackInvoiceConfirm'), this.$t('common.tips.prompt'), {
                confirmButtonText: this.$t('common.btn.ok'),
                cancelButtonText: this.$t('common.btn.cancel'),
                type: 'warning'
              })
            } catch (e) {
              // 取消或关闭确认弹窗，不继续提交
              return
            }
          }
          await this.doCommit()
        } finally {
          this.commitSubmitting = false
        }
        return
      }
      this.commitSubmitting = false
    },
    // 判断当前付款申请是否缺少发票文件（没有任何文件勾选“是否发票”）
    async isLackInvoice() {
      if (!this.billPayment || !this.billPayment.uuid) return 0
      try {
        const res = await checkLackInvoiceFlagFunc({ uuid: this.billPayment.uuid })
        return res.data
      } catch (e) {
        // 查询失败时不影响提交流程（返回 null 交由调用方决定是否覆盖标记/阻断）
        return 0
      }
    },
    // 校验专项费用超出毛利两倍审批，并在提交时合并传递审批信息
    async doApproval() {
      // 校验特殊审批表单必填项
      if (this.$refs.specialForm) {
        const valid = await new Promise(resolve => {
          this.$refs.specialForm.validate(ok => resolve(ok))
        })
        if (!valid) {
          return
        }
      }
      if (!this.specialDialog.applyReason) {
        this.$message.warning(this.$t('CargoMsg.Validation_ApplicationReasonRequired'))
        return
      }
      const approveContent = buildApproveContent(this.specialDialog)
      this.specialDialog.visible = false
      try {
        await this.doCommit(approveContent)
      } finally {
        this.specialDialog.billPaymentUuid = ''
        this.specialDialog.applyReason = ''
        this.specialDialog.fileList = []
      }
    },
    hasUploadedSpecialFile() {
      return !!(this.specialDialog && this.specialDialog.fileList && this.specialDialog.fileList.length > 0)
    },
    getSpecialUploadedFileName() {
      const files = (this.specialDialog && this.specialDialog.fileList) || []
      const names = files.map(f => (f && (f.fileName || f.name)) || '').filter(Boolean)
      if (names.length > 0) {
        return names.join(', ')
      }
      return this.$t('SeaExport.UploadedFile')
    },
    handleRemoveSpecialUpload() {
      this.specialDialog.fileList = []
    },
    // 提交按钮触发事件
    async doCommit(approveContent = null) {
      // REQ-0040：专项费用申请提交前按金额提示企微审批路由（口径对齐后端 ApprovalUtils.sendWechatApproval），确认后才提交
      const approvalRoute = resolveSpecialFeeApprovalRoute({
        paymentType: this.billPayment.paymentType,
        amount: this.billPayment.amount,
        officeCode: this.getBillPaymentOfficeCode()
      })
      if (approvalRoute) {
        try {
          await this.$confirm(this.$t(approvalRoute.tipKey) + this.$t('Payment.confirmSubmitTip'), this.$t('common.tips.prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            type: 'warning'
          })
        } catch (e) {
          // 取消或关闭确认弹窗，不提交
          return
        }
      }
      const keys = [{
        uuid: this.billPayment.uuid,
        version: this.billPayment.version
      }]
      const state = this.isDirectPayment ? 2 : 1
      const params = {
        billPayments: keys,
        state: state,
        operation: 'commit',
        approveContent
      }
      return updateBillPaymentState(params).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_SubmittedSuccessfully'))
        this.billPayment.state = state
        this.$emit('saveSuccess', [this.billPayment])
      }).catch(() => {}).finally(() => {})
    },
    // REQ-0040：解析单据分公司 code 用于卡航判定（branchId→office 缓存，失败回退右上角当前公司，再失败返回空=非卡航 fail-open）
    getBillPaymentOfficeCode() {
      const branchId = this.billPayment && this.billPayment.branchId
      if (branchId) {
        const office = getFilterCacheList(basicCacheKeys.basic_data_Office_All, item => Number(item.officeId) === Number(branchId) || Number(item.id) === Number(branchId))[0]
        if (office && office.code) {
          return office.code
        }
      }
      const currentOffice = this.$store.getters.currentOffice
      return (currentOffice && currentOffice.code) || ''
    },
    // 上次文件后会回调
    async uploadSuccess(rowData) {
      try {
        for (const data of rowData) {
          if (data.fileId) {
            this.specialDialog.fileList.push({
              fileId: data.fileId,
              fileName: data.fileName || data.name || ''
            })
          }
        }
        this.cloudFile.visible = false
      } catch (e) {
        console.log(e)
      }
    },
    // CARGO-47266 P0-创建付款申请增加校验条件，费用复核后才能创建付款申请（费用复核的状态为费用的发票复核的节点）
    async doSavePre() {
      // 判断付款申请类型是否未专项费用申请，若是，则校验费用必须全部是专项费用
      if (this.billPayment.paymentType === '1') {
        let needBlock = false
        for (const item of this.rowData) {
          // 若费用的费用项和结算对象不为专项费用或专项费用资金，则提示且阻断
          if (item.chargeChargeItemId !== 82 || item.chargeAccountId !== 4106) {
            needBlock = true
            break
          }
        }
        if (needBlock) {
          this.$message.warning(this.$t('CargoMsg.Cargo_PaymentOnlySpecificCosts'))
          return false
        }
      }
      let needBlock = false
      for (const item of this.rowData) {
        // 若费用的报价确认为否
        if (item.chargeBusinessQuotationAmount > 0 && !item.chargeBusinessQuotationConfirmd) {
          needBlock = true
          const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeChargeItemId)
          this.$message.warning(this.$t('CargoMsg.Cargo_UnconfirmedSum', [item.jobJobNo, chargeItem.zhName, item.chargeCurrency, item.chargeAmount]))
          break
        }
      }
      if (needBlock) {
        return false
      }
      // 企微必填字段校验：基于后端下发配置中 required=true 的字段，从 this.billPayment 中取值判断（REQ-0033）
      if (this.showEnterpriseWechatFields && this.billPayment) {
        const requiredFields = this.enterpriseWechatFields.filter(f => f && f.prop && f.required)
        const missingField = requiredFields.find(field => !this.hasEnterpriseWechatFieldValue(field))
        if (missingField) {
          const label = this.getEnterpriseWechatLabel(missingField) || missingField.prop
          this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [label]))
          return false
        }
      }

      // 判断是否无票
      this.billPayment.lackInvoiceFlag = await this.isLackInvoice()

      // 判断是否开启验证规则
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      // 查询是否存在节点
      const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code, this.$store.getters.currentOfficeId)
      const billPayments = []
      if (useCheckRule && checkNodeFlag) {
        this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_BILL_PAYMENT_SAVE.code
        this.rowData.forEach((item) => {
          item.lob = item.jobLob
          item.chargeUuid = item.uuid
          item.jobNo = item.jobJobNo
        })
        if (this.billPayment.hasOwnProperty('currencyRateMap') && !this.billPayment.currencyRateMap) {
          delete this.billPayment.currencyRateMap
        }
        if (this.billPayment.hasOwnProperty('chargesAdded') && !this.billPayment.chargesAdded) {
          delete this.billPayment.chargesAdded
        }
        if (this.billPayment.hasOwnProperty('chargesRemoved') && !this.billPayment.chargesRemoved) {
          delete this.billPayment.chargesRemoved
        }
        if (this.billPayment.hasOwnProperty('charges') && !this.billPayment.charges) {
          delete this.billPayment.charges
        }
        if (this.billPayment.hasOwnProperty('dirtyKeyList') && !this.billPayment.dirtyKeyList) {
          delete this.billPayment.dirtyKeyList
        }
        if (this.billPayment.hasOwnProperty('billPayments') && !this.billPayment.billPayments) {
          delete this.billPayment.billPayments
        }
        if (this.billPayment.hasOwnProperty('mapCharge') && !this.billPayment.mapCharge) {
          delete this.billPayment.mapCharge
        }
        if (this.billPayment.hasOwnProperty('params') && !this.billPayment.params) {
          delete this.billPayment.params
        }
        billPayments.push(this.billPayment)
        this.batchCheckingWindow.billPayments = billPayments
        this.batchCheckingWindow.jobs = this.rowData
        this.batchCheckingWindow.callBack = this.doSave
        this.batchCheckingWindow.callBack2 = null
        this.batchCheckingWindow.visible = true
        return false
      } else {
        return await this.doSave()
      }
    },
    // 保存
    async doSave() {
      this.btnSaveEnable = true
      const validate = await this.validateForm()
      if (!validate) {
        this.btnSaveEnable = false
        return false
      }
      const upsertOk = await this.upsertPartnerTitleBankIfNeeded()
      if (!upsertOk) {
        this.btnSaveEnable = false
        return false
      }
      const billPayment = this.billPayment
      if (!billPayment.settlementAgentId) {
        billPayment.settlementAgentId = 0
      }
      billPayment.branchId = this.$store.getters.currentOfficeId
      billPayment.currencyRateMap = this.currencyRateMap
      billPayment.ifHistoryPayment = this.ifHistoryPayment
      if (Object.keys(this.currencyRateMap).length === 0) {
        delete billPayment.currencyRateMap
      }
      if (!billPayment.uuid) { // 新增
        billPayment.jobNo = ''
        billPayment.costInvoiceNo = ''
        billPayment.customerId = -1
        billPayment.inputBy = this.$store.getters.userInfo.userId
        billPayment.inputByDep = this.$store.getters.currentDeptId
        // 随机取第一条费用，将相关属性设置到付款申请上
        this.setBillPaymentProperties(this.rowData[0])
        await this.checkAmountData(billPayment)
        const loading = getLoading4Cxt(this)
        billPayment.location = this.location
        const payload = this.buildBillPaymentPayload(billPayment)
        return await createBillPayment(payload).then(res => {
          if (res.data) {
            // 校验费用是否被修改并界面提示
            if (res.data.dirtyKeyList && res.data.dirtyKeyList.length > 0) {
              for (const item of this.rowData) {
                if (res.data.dirtyKeyList.includes(item.uuid)) {
                  item.ifDirty = true
                }
                this.rowData = [...this.rowData]
              }
              this.$message.error(res.data.dirtyMsg)
            } else {
              // 直接使用后端返回的最新数据，并重取企微表单配置进行反显
              this.billPayment = res.data
              this.loadEnterpriseWechatFormConfig()
            }
          }
          this.billPayment.chargesAdded = []
          this.billPayment.chargesRemoved = []
          this.$emit('reloadData', res.data)
          if (this.billPayment.uuid) {
            this.queryChargeOfBillPayment(this.billPayment.uuid)
          }
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.saveDefaultContent()
          return true
        }).catch(() => {
          return false
        }).finally(() => {
          loading.close()
          this.btnSaveEnable = false
        })
      } else { // 更新
        if (billPayment.chargesRemoved) {
          let jobNoExist = false
          for (const charge of this.rowData) {
            if (billPayment.jobNo === charge.jobJobNo) {
              jobNoExist = true
              break
            }
          }
          // 若付款申请总不存在该业务编号，则重新将相关属性设置到付款申请上
          if (!jobNoExist) {
            this.setBillPaymentProperties2(this.rowData[0])
          }
        }
        for (const charge of this.rowData) {
          if (!charge.billPaymentUuid) {
            const map = {}
            map.uuid = charge.uuid
            map.version = charge.version
            if (!billPayment.chargesAdded) {
              billPayment.chargesAdded = []
              billPayment.chargesAdded.push(map)
            } else {
              const addIndex = billPayment.chargesAdded.findIndex(p => p.uuid === map.uuid)
              if (addIndex < 0) {
                billPayment.chargesAdded.push(map)
              }
            }
          }
        }
        delete billPayment.mapCharge
        delete billPayment.params
        if (!billPayment.chargesAdded) {
          delete billPayment.chargesAdded
        }
        if (!billPayment.chargesRemoved) {
          delete billPayment.chargesRemoved
        }
        await this.checkAmountData(billPayment)
        const loading = getLoading4Cxt(this)
        billPayment.location = this.location
        const payload = this.buildBillPaymentPayload(billPayment)
        return await updateBillPayment(payload).then(res => {
          if (res.data) {
            // 更新后使用后端最新数据，并重取企微表单配置进行反显
            this.billPayment = res.data
            this.loadEnterpriseWechatFormConfig()
          }
          this.billPayment.chargesAdded = []
          this.billPayment.chargesRemoved = []
          this.$emit('reloadData', res.data)
          if (this.billPayment.uuid) {
            this.queryChargeOfBillPayment(this.billPayment.uuid)
          }
          this.$message.success(this.$t('CargoMsg.Cargo_UpdatedSuccessfully'))
          this.saveDefaultContent()
          return true
        }).catch(() => {
          return false
        }).finally(() => {
          loading.close()
          this.btnSaveEnable = false
        })
      }
    },
    // 后端会根据参数 重新计算付款申请金额，与前端传递金额对比
    async checkAmountData(billPayment) {
      billPayment.mapCharge = []
      for (const charge of this.rowData) {
        const map = {}
        map.uuid = charge.uuid
        map.version = charge.version
        billPayment.mapCharge.push(map)
      }
      billPayment.params = {}
      await cache.load(cacheName.CONFIG)
      billPayment.params.isCheck = await Number(cache.config.get('isCheckBillPaymentAmount'))
      billPayment.params.otherCurrency = this.otherCurrencyArray && this.otherCurrencyArray.length > 0 ? this.otherCurrencyArray[0] : ''
      billPayment.params.txtRate = billPayment.rate
      billPayment.params.rateByCharge = this.billPayment.rateByCharge
    },
    async upsertPartnerTitleBankIfNeeded() {
      const paymentType = this.billPayment && this.billPayment.paymentType
      if (paymentType === undefined || paymentType === null || paymentType === '') return true
      if (String(this.billPayment.paymentType) !== '0' && String(this.billPayment.paymentType) !== '4') return true

      const invoiceTitle = this.billPayment && typeof this.billPayment.invoiceTitle === 'string' ? this.billPayment.invoiceTitle.trim() : this.billPayment.invoiceTitle
      if (!invoiceTitle) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.invoiceHeader')]))
        return false
      }
      const bank = this.billPayment && typeof this.billPayment.buyerBank === 'string' ? this.billPayment.buyerBank.trim() : this.billPayment.buyerBank
      if (!bank) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankOfDeposit')]))
        return false
      }
      const bankAccount = this.billPayment && typeof this.billPayment.buyerBankAccount === 'string' ? this.billPayment.buyerBankAccount.trim() : this.billPayment.buyerBankAccount
      if (!bankAccount) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.bankAccount')]))
        return false
      }
      const companyId = Number(this.billPayment && this.billPayment.accountId)
      if (!companyId) {
        this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [this.$t('Payment.settleAccountsTo')]))
        return false
      }

      const currency = this.billPayment && typeof this.billPayment.currency === 'string' ? this.billPayment.currency.trim() : this.billPayment.currency
      const payload = { invoiceTitle, bank, bankAccount, companyId, currency }
      const loading = getLoading4Cxt(this)
      try {
        await upsertPartnerTitleBank(payload)
        return true
      } catch (e) {
        return false
      } finally {
        loading.close()
      }
    },
    // 校验付款申请单
    async validateForm() {
      if (!this.ifHistoryPayment) {
        const currencyList = this.billPayment.payByBillingRate ? this.billCurrencyList : Array.from(this.chargeCurrencySet)
        if (currencyList.length > 3) {
          this.$message.warning(this.$t('CargoMsg.Cargo_BillPaymentCurrencyBeyond', [3]))
          return false
        }
      }
      if (!this.ifJc && (!this.billPayment.ourTitle || !String(this.billPayment.ourTitle).trim())) {
        this.$message.warning(this.$t('CargoMsg.Cargo_OurHeader') + this.$t('CargoMsg.Cargo_CanNotEmpty'))
        return false
      }
      if (this.rowData.length === 0) {
        this.$message.warning(this.$t('Message.PleaseAddCosts'))
        return false
      }
      if (!this.billPayment.deadline) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterPaymentTerm'))
        return false
      }
      if (this.isSpecialExpensePaymentType && !this.billPayment.replaceInvoiceRemark) {
        this.$message.warning(this.$t('Message.replaceInvoiceRemarkRequired'))
        return false
      }
      const aAmount = isNaN(this.billPayment.amount) ? 0 : Number(this.billPayment.amount)
      const bAmount = await this.totalChargeAmount()
      if (aAmount !== bAmount) {
        this.$message.warning(this.$t('Message.ApplicationAmountCheck'))
        return false
      }
      if (this.rowData.length > 0) {
        let checkBranch = true
        let checkBranchId = true
        if (this.billPayment.branchId > 0) {
          checkBranchId = await SecurityUtil.checkChargeDetailBranch(this.billPayment.branchId)
        }
        for (let j = 0; j < this.rowData.length; j++) {
          checkBranch = await SecurityUtil.checkChargeDetailBranch(this.rowData[j].chargeBranchId)
          if (!checkBranch) {
            break
          }
        }
        if (!checkBranch && !checkBranchId) {
          this.$message.warning(this.$t('Message.CheckChargeDetailBranch'))
          return false
        }
      }
      if (this.showEnterpriseWechatFields) {
        const missingField = this.enterpriseWechatFields.find(field => field && field.required && !this.hasEnterpriseWechatFieldValue(field))
        if (missingField) {
          const label = this.getEnterpriseWechatLabel(missingField) || missingField.prop
          this.$message.warning(this.$t('Payment.enterpriseWechatFieldRequired', [label]))
          return false
        }
      }
      return true
    },
    // 统计费用总金额
    async totalChargeAmount() {
      let amount = 0
      // CARGO-38807 H5 BUG 销账/付款申请单界面金额合计显示错误 付款金额
      const amountCurrencys = ChargeUtils.getZeroAmountCurrencys(this.rowData, 'chargeCurrency', 'chargeAmount', 'chargeReceivable')
      for (const charge of this.rowData) {
        if (amountCurrencys.includes(charge.chargeCurrency)) continue
        let rate = 1
        if (this.billPayment.rateByCharge && this.showRateByCharge) {
          rate = charge.chargeExchangeRate
        } else {
          // CARGO-39011 付款申请支持三币种
          if (this.ifHistoryPayment) {
            if (charge.chargeCurrency === this.billPayment.currency) {
              rate = 1
            } else if (this.otherCurrencyArray && this.otherCurrencyArray.length > 0 && charge.chargeCurrency === this.otherCurrencyArray[0]) {
              rate = this.billPayment.rate
            } else {
              rate = await RateUtil.getForeignExchangeRateSafely(this.billPayment.currency, charge.chargeCurrency, new Date(), this.billPayment.branchId)
            }
          } else {
            rate = this.currencyRateMap[charge.chargeCurrency]
          }
        }
        this.chargeRate = rate
        if (charge.chargeReceivable) {
          // amount -= charge.chargeAmount * rate
          amount -= RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
        } else {
          // amount += charge.chargeAmount * rate
          amount += RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(charge.chargeAmount * rate, 2), this.billPayment.currency)
        }
      }
      // return NumberUtils.ToFixed2(amount, 2)
      return NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(amount, this.billPayment.currency), 2)
    },
    setBillPaymentProperties(charge) {
      this.billPayment.advance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (!this.billPayment.jobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else if (this.billPayment.jobNo !== charge.jobJobNo) {
        this.billPayment.jobNo = ''
      }
      if (!this.billPayment.costInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else if (this.billPayment.costInvoiceNo !== charge.chargeInvoiceNo && charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else if (this.billPayment.customerId > 0 && this.billPayment.customerId !== charge.jobCustomerId) {
        this.billPayment.customerId = 0
      }
    },
    /**
     * 更新付款申请时，若付款申请中业务单号对应的全被移除，则重设相关参数
     * @param charge
     */
    setBillPaymentProperties2(charge) {
      this.billPayment.advance = charge.chargeAdvance
      this.billPayment.accountId = charge.chargeAccountId
      if (charge.jobJobNo) {
        this.billPayment.jobNo = charge.jobJobNo
      } else {
        this.billPayment.jobNo = ''
      }
      if (charge.chargeInvoiceNo) {
        this.billPayment.costInvoiceNo = charge.chargeInvoiceNo
      } else {
        this.billPayment.costInvoiceNo = ''
      }
      if (Number('-1') === Number(this.billPayment.customerId)) {
        this.billPayment.customerId = charge.jobCustomerId
      } else {
        this.billPayment.customerId = 0
      }
    },
    // tab 页签点击事件
    handleClick(tab, event) {
      this.activeTabName = tab.name
    },
    // 审批发起回调
    applyCloseAndRefresh(state) {
      // this.billPayment.state = state
      this.workFlowApplyDialog.visible = false
      // this.$emit('saveSuccess', [this.billPayment])
      this.$emit('cancel')
      this.$emit('reloadData', { uuid: this.billPayment.uuid })
    },
    updateExistDistinctTitle(value = false) {
      this.existDistinctTitle = value
    },
    getTitleArray() { // 抬头下拉数据源
      const distinctTitleSet = new Set()
      const titles = []
      this.rowData.forEach(charge => {
        if (charge.chargeInvoiceTitle) {
          if (!distinctTitleSet.has(charge.chargeInvoiceTitle)) {
            distinctTitleSet.add(charge.chargeInvoiceTitle)
            titles.push({ 'title': charge.chargeInvoiceTitle })
          }
        }
      })
      if (distinctTitleSet.size > 1) {
        this.updateExistDistinctTitle(true)
      } else {
        this.updateExistDistinctTitle(false)
      }
      if (this.defaultTitle && !distinctTitleSet.has(this.defaultTitle)) {
        titles.push({ 'title': this.defaultTitle })
      }
      this.titleArray = titles
    },
    async getTitleArrayJc() { // 抬头下拉数据源，锦昶用
      const titles = []
      await queryTitleByCpmIdx(this.billPayment.accountId).then(res => {
        const data = res.data
        if (data && data.length > 0) {
          data.forEach(title => {
            if (title.defaultTitle && !this.billPayment.invoiceTitle) {
              this.billPayment.invoiceTitle = title.title
            }
            titles.push({ 'title': title.title })
          })
          if (data.length === 1 && !this.billPayment.invoiceTitle) {
            this.billPayment.invoiceTitle = data[0].title
          }
        }
      })
      this.titleArray = titles
    },
    checkChargeSameTitle() {
      const distinctTitleSet = new Set()
      for (const charge of this.rowData) {
        if (charge.chargeInvoiceTitle) {
          if (distinctTitleSet.size > 0 && !distinctTitleSet.has(charge.chargeInvoiceTitle)) {
            this.existDistinctTitle = true
            break
          }
          distinctTitleSet.add(charge.chargeInvoiceTitle)
        }
      }
    },
    reconciliationTypeChangeHandler() {
      if (this.reconciliationType === 'job') {
        this.queryJobOfBillPayment(this.billPayment.uuid)
      } else if (this.reconciliationType === 'charge') {
        this.queryChargeOfBillPayment(this.billPayment.uuid)
      }
    },
    updatePrintField(selectedTemplate = null) {
      // 只处理打印的逻辑，非打印触发不处理
      if (selectedTemplate && selectedTemplate.previewType) {
        return
      }
      const keys = []
      if (this.templateSelectorDialog.data.BILLPAYMENT_UUID) {
        keys.push(this.templateSelectorDialog.data.BILLPAYMENT_UUID)
      }
      this.loading = getLoading()
      uploadHasPrint(keys).then(res => {
        if (res.ok && res.data) {
          this.billPayment.version = this.billPayment.version ? this.billPayment.version + 1 : this.billPayment.version
          this.$emit('reloadData')
        }
      }).catch(() => {
      }).finally(() => {
        this.loading.close()
      })
    },
    toSplitCharge() {
      const chooseRows = getGridSelected(this.gridOptions)
      if (!chooseRows || chooseRows.length === 0 || chooseRows.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectExpenseToSplit'))
        return
      }
      const curRow = chooseRows[0]
      const chargeVo = {
        uuid: curRow.uuid,
        jobUuid: curRow.jobUuid,
        chargeItemId: curRow.chargeChargeItemId,
        receivable: curRow.chargeReceivable,
        quantity: curRow.chargeQuantity,
        oversea: curRow.chargeOversea,
        currency: curRow.chargeCurrency,
        measure: curRow.chargeMeasure,
        taxAmount: curRow.chargeTaxAmount,
        taxRate: curRow.chargeTaxRate,
        unitRate: curRow.chargeUnitRate,
        amount: curRow.chargeAmount,
        excludingTaxAmount: curRow.chargeExcludingTaxAmount,
        exchangeRate: curRow.chargeExchangeRate,
        billingAmount: curRow.chargeBillingAmount,
        verifiedAmount: curRow.chargeVerifiedAmount
      }
      this.splitChargeDialog.chargeOrigin = chargeVo // 原始
      this.splitChargeDialog.charge = { ...chargeVo } // 复制
      if (this.splitChargeDialog.charge.verifiedAmount !== 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NonSplitWriteOffExpense'))
        return
      }
      // 费用名称
      this.splitChargeDialog.charge.chargeName = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', this.splitChargeDialog.charge.chargeItemId, 'zhName')
      // 含税价保留小数点
      this.splitChargeDialog.charge.amount = NumberUtils.formatRoundNumber(this.splitChargeDialog.charge.amount, 2)
      this.splitChargeDialog.splitCharge.chargeName = this.splitChargeDialog.charge.chargeName
      // 币种
      this.splitChargeDialog.splitCharge.currency = this.splitChargeDialog.charge.currency
      // 税率
      this.splitChargeDialog.splitCharge.taxRate = this.splitChargeDialog.charge.taxRate
      // 重置
      this.splitChargeDialog.splitCharge.amount = 0.0
      this.splitChargeDialog.splitCharge.taxAmount = 0.0
      this.splitChargeDialog.splitCharge.excludingTaxAmount = 0.0
      this.splitChargeDialog.btnSplitEnable = false
      this.splitChargeDialog.onlyChangeQuantity = LocalStorageUtilsNew.hasConfiguration('splitChargeOnlyChangeQuantity') ? Boolean(LocalStorageUtilsNew.getConfiguration('splitChargeOnlyChangeQuantity')) : true
      this.splitChargeDialog.show = true
    },
    onlyChangeQuantityChangeHandler(value) {
      LocalStorageUtilsNew.setConfiguration('splitChargeOnlyChangeQuantity', this.splitChargeDialog.onlyChangeQuantity)
    },
    // 拆分费用含税金额
    amountChangeHandler(value) {
      this.splitChargeDialog.splitCharge.amount = RateUtil.getAmountByCurrency(value, this.splitChargeDialog.splitCharge.currency)
      this.splitChargeDialog.charge.amount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.chargeOrigin.amount - this.splitChargeDialog.splitCharge.amount, this.splitChargeDialog.splitCharge.currency), 2)
      // 不含税金额
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount / (this.splitChargeDialog.splitCharge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.splitCharge.excludingTaxAmount = rAmount
      this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      // CARGO-29312，开票详情 费用拆分 提示‘费用金额不等于不含税价加上税额’
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.splitCharge.amount -
          this.splitChargeDialog.splitCharge.excludingTaxAmount -
          this.splitChargeDialog.splitCharge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.splitCharge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.splitCharge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
    },
    // 确定拆分
    doSplitCharge() {
      this.splitChargeDialog.btnSplitEnable = true
      if (this.splitChargeDialog.splitCharge.amount === 0) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseEnterSplitAmount'))
      } else if (this.splitChargeDialog.charge.quantity > 1 && !this.splitChargeDialog.onlyChangeQuantity) {
        this.$confirm(this.$t('CargoMsg.Cargo_NOEGT1ICTSTNWBST1C'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(() => {
          this.doSplit()
        }).catch(() => {
          this.splitChargeDialog.btnSplitEnable = false
        })
      } else {
        this.doSplit()
      }
    },
    // 拆分
    doSplit() {
      if (this.splitChargeDialog.splitCharge.amount > this.splitChargeDialog.chargeOrigin.amount) {
        this.splitChargeDialog.btnSplitEnable = false
        this.$message.warning(this.$t('Message.TipsOnSplittingExpenses'))
        return
      }
      // 拆分的费用
      this.splitChargeDialog.splitCharge.quantity = 1
      this.splitChargeDialog.splitCharge.billingAmount = 0
      this.splitChargeDialog.splitCharge.unitRate = this.splitChargeDialog.splitCharge.excludingTaxAmount
      // 要拆分的费用
      const rAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount / (this.splitChargeDialog.charge.taxRate / 100 + 1), this.splitChargeDialog.splitCharge.currency), 2)
      this.splitChargeDialog.charge.excludingTaxAmount = rAmount
      this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.amount - rAmount, this.splitChargeDialog.splitCharge.currency), 2)
      if (RateUtil.useAmountCarryRule()) {
        const c = RateUtil.getAmountByCurrency(NumberUtils.ToFixed2(this.splitChargeDialog.charge.amount -
          this.splitChargeDialog.charge.excludingTaxAmount -
          this.splitChargeDialog.charge.taxAmount, 6), this.splitChargeDialog.splitCharge.currency)
        if (Math.abs(c) !== 0) {
          this.splitChargeDialog.charge.taxAmount = NumberUtils.roundHalfUp(RateUtil.getAmountByCurrency(this.splitChargeDialog.charge.taxAmount + c, this.splitChargeDialog.splitCharge.currency), 2)
        }
      }
      this.splitChargeDialog.charge.quantity = 1
      this.splitChargeDialog.charge.unitRate = this.splitChargeDialog.charge.excludingTaxAmount
      this.splitChargeDialog.charge.chargeSource = 6
      this.splitChargeDialog.splitCharge.chargeSource = 6
      this.splitChargeDialog.charge.splitChargeOnlyChangeQuantity = this.splitChargeDialog.onlyChangeQuantity
      const charges = []
      charges.push(this.splitChargeDialog.charge)
      charges.push(this.splitChargeDialog.splitCharge)
      this.loading = getLoading()
      saveSplitCharge(charges, this.location).then(res => {
        this.splitChargeDialog.show = false
        const rowData = []
        for (const charge of this.rowData) {
          if (charge.uuid === this.splitChargeDialog.chargeOrigin.uuid) {
            continue
          }
          rowData.push(charge)
        }
        for (const charge of res.data) {
          rowData.push(charge)
        }
        this.rowData = rowData
        this.$message.success(this.$t('CargoMsg.Cargo_SplitSuccessfully'))
      }).catch(() => {
        this.splitChargeDialog.btnSplitEnable = false
      }).finally(() => {
        this.loading.close()
      })
    },
    // 同步发票附件勾选修改
    saveDefaultContent() {
      const item = {}
      item.paymentType = this.billPayment.paymentType
      item.ourTitle = this.billPayment.ourTitle
      LocalStorageUtilsNew.setConfiguration('billPaymentFormPage', item)
    }
  }
}
</script>

<style lang="scss">
.bill-payment-dialog-by-job {
  display: flex;
  flex-direction: column;
  // 只对【多选】企业微信下拉做输入框文字隐藏，保留 tag 展示
  .enterprise-wechat-select--multiple {
    .el-input__inner {
      font-size: 0;
    }
    .el-select__tags-text,
    .el-tag__content {
      font-size: 12px;
    }
  }
  .custom-header{
    width:100%;display: flex;justify-content:space-between;
    span,i {
      font-size:16px
    }
  }
  .el-dialog__body{
    display: flex;
    flex-direction: column;
    flex:1;
    padding: 10px!important;
  }
  .el-scrollbar__wrap {
    overflow-x: auto;
  }
  .custom-textarea {
    textarea {
      resize: none;
    }
  }
  .el-tabs__header {
    margin-bottom: 5px;
  }
  .job-types-checkbox-group {
    display: inline-flex;
    flex-wrap: wrap;
    max-width: 520px;
    column-gap: 12px;
  }
  .app-main-inner-row {
    display: flex;
    justify-content: space-between;
    padding: 8px 16px 0 16px;
  }
  .reconciliation-mode-top {
    padding: 0 15px 8px;
  }
  .upload-file-row {
    display: flex;
    align-items: center;
  }
  .upload-file-name {
    max-width: 420px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .upload-file-remove {
    padding: 0 4px;
    margin-left: 6px;
    line-height: 1;
  }
}
</style>
